<template>
  <ValidationObserver ref="newQuotationForm" v-slot="{ invalid }">
    <div :class="`${isLanding ? 'form-landing' : 'p-2'}`">
      <vx-card :class="!showPanel ? 'painel-no-border' : 'painel-border'">
        <div
          class="text-center mb-5"
          v-if="hideLogo != true && logo != '' && !isLanding"
        >
          <img
            :src="logo"
            width="70%"
            style="display: inline; max-width: 250px"
            data-testId="logo-image"
          />
        </div>

        <div
          v-if="
            !isEdition &&
            $can(
              PERMISSIONS_ACTIONS.CHANGE_PROPOSAL_BROKER,
              PERMISSIONS_NAMES.QUOTATIONS,
            ) &&
            step === 0
          "
          id="broker-selection"
        >
          <div class="vx-row">
            <div class="vx-col sm:w-1/4 w-full mb-2">
              <span>Selecione a Corretora</span>
              <ValidationProvider
                name="Corretora"
                rules="required"
                v-slot="{ errors }"
              >
                <v-select
                  :options="brokers"
                  id="Corretora"
                  v-model="fieldsWithValidation.brokerId"
                  :reduce="(item) => item.id"
                  :danger="!!errors.length"
                  data-testId="broker-selection"
                ></v-select>
                <span
                  v-show="!!errors.length"
                  class="text-danger"
                  data-testId="broker-selection-error"
                >
                  {{ errors[0] }}
                </span>
              </ValidationProvider>
            </div>
          </div>
        </div>

        <div v-if="step === 1 || isEdition">
          <vs-row vs-type="flex" class="no-padding-cols">
            <vs-col
              v-if="isEdition && quotation"
              class="flex w-auto justify-start items-center mb-3"
            >
              <h2 data-testId="quotation-id">
                Cotação {{ quotation.proposal_id }} - AUTO
              </h2>
            </vs-col>
            <vs-col
              v-if="isEdition"
              class="flex w-auto flex-grow justify-end items-center mb-3 gap-2"
            >
              <vs-button
                v-if="hasPdf"
                @click="openPdf()"
                color="success"
                type="gradient"
                icon-pack="feather"
                icon="icon-file-text"
                class="rounded-full"
                v-tooltip="getLabelContrato()"
                data-testId="open-pdf-button"
              />

              <vs-button
                v-if="
                  isQuotationOpen &&
                  !isQuotationRefused &&
                  permissaoRecusaCorretora
                "
                @click="recusarCorretora(quotation.id)"
                color="danger"
                type="gradient"
                icon-pack="feather"
                icon="icon-x"
                class="rounded-full"
                v-tooltip="'Recusar'"
                data-testId="refuse-broker-button"
              />

              <vs-button
                v-if="canShowModalLogs"
                @click="openModalLogs()"
                color="primary"
                type="gradient"
                icon-pack="feather"
                icon="icon-list"
                class="rounded-full"
                v-tooltip="'Histórico de Alterações'"
                data-testId="open-logs-button"
              />

              <vs-button
                @click="openModalHistoricoMensageria()"
                icon-pack="feather"
                icon="icon-mail"
                class="rounded-full purple-gradient-btn"
                v-tooltip="'Histórico de Mensageria'"
                data-testId="open-messaging-history-button"
              />
            </vs-col>
          </vs-row>
          <p v-if="getCreatedAt" data-testId="quotation-date">
            <span class="font-bold">Data da cotação:</span> {{ getCreatedAt }}
          </p>

          <div v-if="isEdition">
            <div class="form-part-title mt-6 mb-6">
              <span>Corretora</span>
            </div>

            <div class="vx-row">
              <div class="vx-col sm:w-1/4 w-full mb-2">
                <span>Selecione a Corretora</span>
                <ValidationProvider
                  name="Corretora"
                  rules="required"
                  v-slot="{ errors }"
                >
                  <v-select
                    :options="brokers"
                    id="Corretora"
                    v-model="fieldsWithValidation.brokerId"
                    :reduce="(item) => item.id"
                    :danger="!!errors.length"
                    :disabled="isEdition"
                    data-testId="broker-selection-edit"
                  ></v-select>
                  <span
                    v-show="!!errors.length"
                    class="text-danger"
                    data-testId="broker-selection-edit-error"
                  >
                    {{ errors[0] }}
                  </span>
                </ValidationProvider>
              </div>
            </div>
          </div>

          <div class="form-part-title mt-6 mb-6">
            <span>Renovação e Bônus</span>
          </div>

          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/2 w-full mb-2">
              <label for="Bonus" class="vs-select--label"
                >É uma renovação?</label
              >
              <ValidationProvider
                name="É uma renovação?"
                rules="required"
                v-slot="{ errors }"
              >
                <v-select
                  :options="insuranceCompanies"
                  id="É uma renovação?"
                  v-model="fieldsWithValidation.insuranceCompanyCode"
                  :reduce="(item) => item.id"
                  :danger="!!errors.length"
                  :filter="filterOptions"
                  :disabled="isCanceled || disableForm"
                  data-testId="renewal-selection"
                >
                  <template #selected-option="option">
                    {{ getSelectedCongenerLabel(option) }}
                  </template></v-select
                >
                <span
                  v-show="!!errors.length"
                  class="text-danger"
                  data-testId="renewal-selection-error"
                >
                  {{ errors[0] }}
                </span>
              </ValidationProvider>
            </div>

            <div v-if="isRenovationByCNSeg" class="vx-col sm:w-1/4 w-full mb-2">
              <label for="Bonus" class="vs-select--label">Nível de Bônus</label>
              <ValidationProvider
                name="Nível de Bônus"
                rules="required"
                v-slot="{ errors }"
              >
                <v-select
                  :options="bonusesLevel"
                  id="Nível de Bônus"
                  v-model="fieldsWithValidation.bonus"
                  :reduce="(item) => item.id"
                  :danger="!!errors.length"
                  :disabled="isCanceled || disableForm"
                  data-testId="bonus-level"
                ></v-select>
                <span
                  v-show="!!errors.length"
                  class="text-danger"
                  data-testId="bonus-level-error"
                >
                  {{ errors[0] }}
                </span>
              </ValidationProvider>
            </div>
          </div>
          <div class="form-part-title mt-6 mb-6">
            <span>Dados do Segurado</span>
          </div>

          <div class="vx-row mb-4">
            <div class="vx-col w-full sm:w-1/4">
              <ValidationProvider
                name="CPF-CNPJ"
                rules="required|cpf_cnpj_min|cpf_cnpj"
                v-slot="{ errors }"
              >
                <vs-input
                  v-model="fieldsWithValidation.cpfcnpj"
                  class="w-full"
                  label="CPF-CNPJ"
                  id="cpfcnpjInput"
                  v-mask="[DOCUMENT_MASK.CPF_WITH_CNPJ, DOCUMENT_MASK.CNPJ]"
                  @input="fieldsWithValidation.cpfcnpj = $event.toUpperCase()"
                  :danger="!!errors.length"
                  :disabled="isCanceled || disableForm"
                  data-testId="insured-cpf-cnpj"
                />
                <span
                  v-show="!!errors.length"
                  class="text-danger"
                  data-testId="insured-cpf-cnpj-error"
                  >{{ errors[0] }}</span
                >
              </ValidationProvider>
            </div>
          </div>

          <div
            v-if="
              fieldsWithValidation.cpfcnpj.length >=
              DOCUMENT_LENGTH_WITH_MASK.CPF
            "
            class="vx-row mb-4"
          >
            <div class="vx-col w-full sm:w-5/12">
              <ValidationProvider
                name="Nome"
                rules="required|nome"
                v-slot="{ errors }"
              >
                <vs-input
                  class="w-full"
                  :label="
                    isPerson ? 'Nome Completo / Nome Social' : 'Razão Social'
                  "
                  v-model="fieldsWithValidation.name"
                  id="Nome"
                  :danger="!!errors.length"
                  :disabled="isCanceled || disableForm"
                  data-testId="insured-name"
                />
                <span
                  v-show="!!errors.length"
                  class="text-danger"
                  data-testId="insured-name-error"
                  >{{ errors[0] }}</span
                >
              </ValidationProvider>
            </div>

            <div
              v-if="isPerson"
              class="vx-col w-full sm:w-2/12 checkBoxNomeSocial"
            >
              <vs-checkbox
                v-model="socialName"
                :disabled="isCanceled || disableForm"
                data-testId="insured-social-name"
              >
                Nome Social?
              </vs-checkbox>
            </div>

            <div
              v-if="
                socialName &&
                fieldsWithValidation.cpfcnpj.length >=
                  DOCUMENT_LENGTH_WITH_MASK.CPF
              "
              class="vx-col w-full sm:w-5/12"
            >
              <ValidationProvider
                name="Nome Civil"
                rules="required|nome"
                v-slot="{ errors }"
              >
                <vs-input
                  class="w-full"
                  label="Nome Civil"
                  v-model="fieldsWithValidation.civilName"
                  id="Nome Civil"
                  :danger="!!errors.length"
                  :disabled="isCanceled || disableForm"
                  data-testId="insured-civil-name"
                />
                <span
                  v-show="!!errors.length"
                  class="text-danger"
                  data-testId="insured-civil-name-error"
                  >{{ errors[0] }}</span
                >
              </ValidationProvider>
            </div>
          </div>

          <div class="form-part-title mt-6 mb-6">
            <span>Dados do Condutor</span>
          </div>

          <div class="vx-row mb-4">
            <div v-if="isPerson" class="vx-col sm:w-1/4 w-full">
              <vs-checkbox
                v-model="insuredIsMainDriver"
                :disabled="isCanceled || disableForm"
                data-testId="insured-is-main-driver"
              >
                Condutor é o segurado?
              </vs-checkbox>
            </div>

            <div class="vx-col sm:w-1/4 w-full">
              <ValidationProvider
                name="CPF-CNPJ condutor"
                :rules="{
                  required: true,
                  min: DOCUMENT_LENGTH_WITH_MASK.CPF,
                  cpf_cnpj: true,
                }"
                v-slot="{ errors }"
              >
                <vs-input
                  v-model="driverCpfCnpj"
                  class="w-full"
                  label="CPF"
                  id="CPF-CNPJ condutor"
                  :disabled="insuredIsMainDriver || disableForm"
                  v-mask="DOCUMENT_MASK.CPF_ONLY"
                  :danger="!!errors.length"
                  data-testId="driver-cpf-cnpj"
                />
                <span
                  v-show="!!errors.length"
                  class="text-danger"
                  data-testId="driver-cpf-cnpj-error"
                  >{{ errors[0] }}
                </span>
              </ValidationProvider>
            </div>

            <div
              v-if="driverCpfCnpj.length >= DOCUMENT_LENGTH_WITH_MASK.CPF"
              class="vx-col sm:w-1/4 w-full"
            >
              <ValidationProvider
                name="Data de Nascimento"
                rules="required|date_format:dd/MM/yyyy|min_age|max_age"
                v-slot="{ errors }"
              >
                <vs-input
                  name="Data de Nascimento"
                  class="w-full"
                  label="Data de Nascimento"
                  v-mask="'##/##/####'"
                  v-model="fieldsWithValidation.driverBirthdate"
                  :danger="!!errors.length"
                  :disabled="isCanceled || disableForm"
                  data-testId="driver-birthdate"
                />
                <span
                  v-show="!!errors.length"
                  class="text-danger"
                  data-testId="driver-birthdate-error"
                  >{{ errors[0] }}</span
                >
              </ValidationProvider>
            </div>

            <div
              v-if="driverCpfCnpj.length >= DOCUMENT_LENGTH_WITH_MASK.CPF"
              class="vx-col sm:w-1/4 w-full"
            >
              <label for="Tipo de CNH" class="vs-select--label"
                >Sexo de Nascimento</label
              >
              <ValidationProvider
                name="Sexo"
                rules="required"
                v-slot="{ errors }"
              >
                <v-select
                  label="label"
                  id="Sexo"
                  v-model="fieldsWithValidation.driverGender"
                  :options="LIST_SEXO"
                  :danger="!!errors.length"
                  :disabled="isCanceled || disableForm"
                  data-testId="driver-gender"
                ></v-select>
                <span
                  v-show="!!errors.length"
                  class="text-danger"
                  data-testId="driver-gender-error"
                  >{{ errors[0] }}</span
                >
              </ValidationProvider>
            </div>
          </div>

          <div
            v-if="driverCpfCnpj.length >= DOCUMENT_LENGTH_WITH_MASK.CPF"
            class="vx-row mb-4"
          >
            <div class="vx-col w-full sm:w-5/12">
              <ValidationProvider
                name="Nome Completo / Nome Social"
                rules="required|is-person-name"
                v-slot="{ errors }"
              >
                <vs-input
                  class="w-full"
                  label="Nome Completo / Nome Social"
                  v-model="fieldsWithValidation.driverName"
                  id="Nome Completo / Nome Social"
                  data-testId="driver-full-name"
                  :disabled="insuredIsMainDriver || isCanceled || disableForm"
                  :danger="!!errors.length"
                  key="driver-full-name-input"
                />
                <span
                  v-show="!!errors.length"
                  class="text-danger"
                  data-testId="driver-full-name-error"
                  >{{ errors[0] }}</span
                >
              </ValidationProvider>
            </div>

            <div
              v-if="driverCpfCnpj.length >= DOCUMENT_LENGTH_WITH_MASK.CPF"
              class="vx-col w-full sm:w-2/12 checkBoxNomeSocial"
            >
              <vs-checkbox
                :disabled="insuredIsMainDriver || isCanceled || disableForm"
                v-model="driverSocialName"
                data-testId="driver-social-name-checkbox"
              >
                Nome Social?
              </vs-checkbox>
            </div>

            <div v-if="driverSocialName" class="vx-col w-full sm:w-5/12">
              <ValidationProvider
                name="Nome Civil Condutor"
                rules="required|is-person-name"
                v-slot="{ errors }"
              >
                <vs-input
                  class="w-full"
                  label="Nome Civil Condutor"
                  v-model="fieldsWithValidation.driverCivilName"
                  id="Nome Civil Condutor"
                  data-testId="driver-civil-name"
                  :disabled="insuredIsMainDriver || isCanceled || disableForm"
                  :danger="!!errors.length"
                />
                <span
                  v-show="!!errors.length"
                  class="text-danger"
                  data-testId="driver-social-name-error"
                  >{{ errors[0] }}</span
                >
              </ValidationProvider>
            </div>
          </div>

          <div class="form-part-title mt-6 mb-6">
            <span>CEP de Pernoite</span>
          </div>

          <div class="vx-row mb-4">
            <div class="vx-col sm:w-1/4 w-full">
              <label for="CEP" class="vs-select--label">CEP</label>
              <ValidationProvider
                name="CEP"
                rules="required|min:10"
                v-slot="{ errors }"
              >
                <vs-input
                  class="w-full"
                  id="CEP"
                  @keyup.native="keymonitor"
                  v-model="fieldsWithValidation.overnightZipCode"
                  :danger="!!errors.length"
                  v-mask="'##.###-###'"
                  data-testId="overnight-zipcode"
                  :disabled="isCanceled || disableForm"
                />
                <span
                  v-show="!!errors.length"
                  class="text-danger"
                  data-testId="overnight-zipcode-error"
                >
                  {{ errors[0] }}
                </span>
              </ValidationProvider>
            </div>

            <div
              v-if="fieldsWithValidation.overnightZipCode.length === 10"
              class="vx-col sm:w-3/4 w-full"
            >
              <label for="Endereco" class="vs-select--label">Logradouro</label>
              <ValidationProvider
                name="Logradouro"
                rules="required"
                v-slot="{ errors }"
              >
                <vs-input
                  v-model="fieldsWithValidation.overnightStreet"
                  class="w-full"
                  id="Endereco"
                  data-testId="overnight-street"
                  :danger="!!errors.length"
                  :disabled="
                    isCanceled ||
                    disableForm ||
                    (hasCepApiReturned && hasCepApiReturnedOvernightStreet)
                  "
                />
                <span
                  v-show="!!errors.length"
                  class="text-danger"
                  data-testId="overnight-street-error"
                >
                  {{ errors[0] }}
                </span>
              </ValidationProvider>
            </div>
          </div>

          <div
            v-if="fieldsWithValidation.overnightZipCode.length === 10"
            class="vx-row mb-4"
          >
            <div class="vx-col sm:w-3/12 w-full">
              <label for="Bairro" class="vs-select--label">Bairro</label>
              <ValidationProvider
                name="Bairro"
                rules="required"
                v-slot="{ errors }"
              >
                <vs-input
                  v-model="fieldsWithValidation.overnightNeighborhood"
                  class="w-full"
                  id="Bairro"
                  data-testId="overnight-neighborhood"
                  :danger="!!errors.length"
                  :disabled="
                    isCanceled ||
                    disableForm ||
                    (hasCepApiReturned &&
                      hasCepApiReturnedOvernightNeighborhood)
                  "
                />
                <span
                  v-show="!!errors.length"
                  class="text-danger"
                  data-testId="overnight-neighborhood-error"
                >
                  {{ errors[0] }}
                </span>
              </ValidationProvider>
            </div>
            <div class="vx-col sm:w-2/12">
              <label for="Número" class="vs-select--label">Número</label>
              <ValidationProvider
                name="Número"
                rules="max:10"
                v-slot="{ errors }"
              >
                <vs-input
                  class="w-full"
                  id="Número"
                  v-model="fieldsWithValidation.overnightNumber"
                  :danger="!!errors.length"
                  :disabled="isCanceled || disableForm"
                  data-testId="overnight-number"
                />
                <span
                  v-show="!!errors.length"
                  class="text-danger"
                  data-testId="overnight-number-hood"
                  >{{ errors[0] }}</span
                >
              </ValidationProvider>
            </div>
            <div class="vx-col sm:w-2/12">
              <label for="Complemento Pernoite" class="vs-select--label"
                >Complemento</label
              >
              <ValidationProvider
                name="Complemento Pernoite"
                rules="max:40"
                v-slot="{ errors }"
              >
                <vs-input
                  v-model="fieldsWithValidation.overnightComplement"
                  class="w-full"
                  id="Complemento Pernoite"
                  :disabled="isCanceled || disableForm"
                  maxlength="40"
                  data-testId="overnight-address-compliment"
                />
                <span
                  v-show="!!errors.length"
                  class="text-danger"
                  data-testId="overnight-address-compliment-error"
                >
                  {{ errors[0] }}
                </span>
              </ValidationProvider>
            </div>
            <div class="vx-col sm:w-2/12">
              <label for="Estado" class="vs-select--label">Estado</label>
              <ValidationProvider
                name="Estado"
                rules="required|estado_pernoite"
                v-slot="{ errors }"
              >
                <v-select
                  :options="estados"
                  id="Estado"
                  autocomplete="off"
                  @input="
                    getCityData(
                      'domMunicipio',
                      'cidades',
                      'nomeCidade',
                      'idCidade',
                    ),
                      selectState()
                  "
                  v-model="fieldsWithValidation.overnightState"
                  placeholder="Selecione o Estado"
                  label="label"
                  data-testId="overnight-state"
                  :danger="!!errors.length"
                  :disabled="
                    isCanceled ||
                    disableForm ||
                    (hasCepApiReturned && hasCepApiReturnedOvernightState)
                  "
                ></v-select>
                <span
                  v-show="!!errors.length"
                  class="text-danger"
                  data-testId="overnight-state-error"
                >
                  {{ errors[0] }}
                </span>
              </ValidationProvider>
            </div>
            <div class="vx-col sm:w-3/12">
              <label for="Cidade" class="vs-select--label">Cidade</label>
              <ValidationProvider
                name="Cidade"
                rules="required"
                v-slot="{ errors }"
              >
                <v-select
                  :options="cidades"
                  id="Cidade"
                  @input="selectCity()"
                  v-model="fieldsWithValidation.overnightCity"
                  placeholder="Selecione a Cidade"
                  label="label"
                  data-testId="overnight-city"
                  :danger="!!errors.length"
                  :disabled="
                    isCanceled ||
                    disableForm ||
                    (hasCepApiReturned && hasCepApiReturnedOvernightCity)
                  "
                ></v-select>
                <span
                  v-show="!!errors.length"
                  class="text-danger"
                  data-testId="overnight-city-error"
                >
                  {{ errors[0] }}
                </span>
              </ValidationProvider>
            </div>
          </div>

          <div class="form-part-title mt-6 mb-6">
            <span>Dados do Veículo</span>
          </div>

          <div class="vx-row mb-4">
            <div class="vx-col sm:w-1/6 w-full">
              <vs-checkbox
                v-model="isBrandNew"
                @change="clearAllVehicleData()"
                data-testId="is-brand-new"
                :disabled="disableForm"
              >
                Veículo Zero
              </vs-checkbox>
              <span
                v-show="hasZeroKmError"
                class="text-danger"
                data-testId="is-brand-new-error"
                >Veículo não pode ser 0 km</span
              >
            </div>

            <div class="vx-col sm:w-1/5 w-full">
              <label for="" class="vs-select--label">Placa</label>
              <ValidationProvider
                name="Placa"
                rules="length:8"
                v-slot="{ errors }"
              >
                <the-mask
                  name="Placa"
                  mask="AAA-#XX#"
                  style="text-transform: uppercase"
                  id="input-2"
                  class="vs-inputx vs-input--input normal hasValue w-full"
                  v-model="fieldsWithValidation.vehiclePlate"
                  :masked="true"
                  @input="keymonitorPlate"
                  :danger="!!errors.length"
                  data-testId="vehicle-plate"
                  :disabled="disableForm"
                />
                <span
                  v-show="!!errors.length"
                  class="text-danger"
                  data-testId="vehicle-plate-error"
                  >{{ errors[0] }}</span
                >
              </ValidationProvider>
            </div>

            <div class="vx-col sm:w-1/5 w-full">
              <ValidationProvider
                name="Chassi"
                rules="min:17|max:17"
                v-slot="{ errors }"
              >
                <vs-input
                  class="vs-inputx normal hasValue w-full"
                  label="Chassi"
                  v-model="fieldsWithValidation.vehicleChassis"
                  id="Chassi"
                  maxlength="17"
                  :danger="!!errors.length"
                  @input="keymonitorChassi"
                  :disabled="!isBrandNew || disableForm"
                  data-testId="vehicle-chassis"
                />
                <span
                  v-show="!!errors.length"
                  class="text-danger"
                  data-testId="vehicle-chassis-error"
                  >{{ errors[0] }}</span
                >
              </ValidationProvider>
            </div>
          </div>

          <div v-if="!selectedFipeModel" class="vx-row mb-4">
            <div class="vx-col sm:w-1/4 w-full">
              <label for="" class="vs-select--label">Marca</label>
              <ValidationProvider
                name="Marca"
                rules="required"
                v-slot="{ errors }"
              >
                <v-select
                  :options="vehicleBrands"
                  id="Marca"
                  @input="getVehicleModels()"
                  v-model="fieldsWithValidation.vehicleBrandId"
                  label="label"
                  data-testId="vehicle-brand"
                  :disabled="disableForm"
                ></v-select>
                <span
                  v-show="!!errors.length"
                  class="text-danger"
                  data-testId="vehicle-brand-error"
                  >{{ errors[0] }}</span
                >
              </ValidationProvider>
            </div>

            <div class="vx-col sm:w-1/4 w-full">
              <label for="" class="vs-select--label">Modelo</label>
              <ValidationProvider
                name="Modelo"
                rules="required"
                v-slot="{ errors }"
              >
                <v-select
                  :options="vehicleModels"
                  id="Modelo"
                  @input="getVehicleYears()"
                  v-model="fieldsWithValidation.vehicleModelId"
                  label="label"
                  data-testId="vehicle-model"
                  :disabled="disableForm"
                ></v-select>
                <span
                  v-show="!!errors.length"
                  class="text-danger"
                  data-testId="vehicle-model-error"
                  >{{ errors[0] }}</span
                >
              </ValidationProvider>
            </div>

            <div class="vx-col sm:w-1/4 w-full">
              <label for="" class="vs-select--label">Ano Modelo</label>
              <ValidationProvider
                name="Ano Modelo"
                rules="required"
                v-slot="{ errors }"
              >
                <v-select
                  :options="vehicleYearsModel"
                  id="Ano Modelo"
                  @input="getVehicleModelsByYear()"
                  v-model="fieldsWithValidation.vehicleYearModel"
                  label="label"
                  data-testId="vehicle-year-model"
                  :disabled="disableForm"
                ></v-select>
                <span
                  v-show="!!errors.length"
                  class="text-danger"
                  data-testId="vehicle-year-model-error"
                  >{{ errors[0] }}</span
                >
              </ValidationProvider>
            </div>
          </div>

          <div v-if="selectedFipeModel" class="vx-row mb-4">
            <vs-alert active="true" class="vehicle-alert text-light mt-3 mb-3">
              <div class="w-full flex vs-align-center">
                <p class="w-full p-3">
                  {{ vehicleResult.brand }}/{{ selectedFipeModel.model_text }} -
                  {{ vehicleResult.year }}/{{ selectedFipeModel.year_model }}
                </p>
                <vs-button
                  color="primary"
                  type="flat"
                  icon="cached"
                  size="large"
                  :disabled="disableForm"
                  @click="showSelectPlateModal = true"
                  data-testId="vehicle-refresh"
                ></vs-button>
              </div>
            </vs-alert>
          </div>
          <div v-if="fieldsWithValidation.fipeResult" class="vx-row mb-4">
            <div class="vx-col sm:w-1/2 w-full">
              <label for class="vs-input--label">Preço FIPE</label>
              <ValidationProvider
                name="Preço FIPE"
                rules="required"
                v-slot="{ errors }"
              >
                <money
                  class="vs-inputx vs-input--input normal"
                  id="Preço FIPE"
                  v-model="fieldsWithValidation.fipeResult.amount"
                  v-bind="money"
                  :danger="!!errors.length"
                  disabled
                  data-testId="fipe-price"
                ></money>
                <span
                  v-show="!!errors.length"
                  class="text-danger"
                  data-testId="fipe-price-error"
                  >{{ errors[0] }}</span
                >
              </ValidationProvider>
            </div>

            <div class="vx-col sm:w-1/2 w-full container">
              <label>
                Código FIPE:
                <span class="font-bold">{{
                  vehicleFipeCode || fieldsWithValidation.fipeResult.fipe_code
                }}</span>
              </label>
            </div>
          </div>
          <div v-if="increases.length" class="form-part-title mt-6 mb-6">
            <span>Questionário de Avaliação de Risco</span>
          </div>

          <div v-if="increases.length" class="vx-row mb-4">
            <div
              v-for="(item, index) in increases"
              :key="index"
              class="vx-col sm:w-1/3 w-full mb-"
            >
              <label
                :for="item.question"
                class="vs-select--label"
                :data-testId="`increase-label-${item.id}`"
              >
                {{ item.question }}
              </label>
              <ValidationProvider
                :name="item.question"
                rules="required"
                v-slot="{ errors }"
              >
                <v-select
                  :options="item.answers"
                  :id="item.question"
                  v-model="fieldsWithValidation.increasesAnswers[item.id]"
                  label="response"
                  placeholder="Selecione"
                  :danger="!!errors.length"
                  :disabled="isCanceled || disableForm"
                  :data-testId="`select-${item.id}`"
                ></v-select>
                <span
                  v-show="!!errors.length"
                  class="text-danger"
                  :data-testId="`error-${item.id}`"
                >
                  {{ errors[0] }}
                </span>
              </ValidationProvider>
            </div>
          </div>

          <div v-if="isEdition">
            <div class="form-part-title mt-6 mb-6">
              <span>Produtos e Prêmio</span>
            </div>

            <div class="flex flex-col gap-16 lg:gap-18 mb-4">
              <ProductsList
                :disabled="!canEditAndTransmit"
                :products="products"
                :selectedProducts="selectedProducts"
                @update:selectedProducts="updateSelectedProducts"
                @update:isValidRcfValue="updateIsValidRcfValue"
              ></ProductsList>
              <div class="loading-financial-wrapper">
                <div class="loading-financial-list-wrapper">
                  <CarregamentosForm
                    :formData="form"
                    :premio="prize ? prize.prize_without_discount : 0"
                    :enableDiscount="true"
                    :isCanceled="isCanceled || !canEditAndTransmit"
                    ref="CarregamentosForm"
                    parent="1"
                    @recalcular="recalculate()"
                    :brokerId="fieldsWithValidation.brokerId"
                    data-testId="carregamentos-form"
                    :brokerAccountBalanceInsufficient="
                      brokerAccountBalanceInsufficient
                    "
                    :brokerAccountBalanceUsed="brokerAccountBalanceUsed"
                    :nextMonthDiscountMessage="nextMonthDiscountMessage"
                    :insuranceCompanyCode="
                      fieldsWithValidation.insuranceCompanyCode
                    "
                  />
                </div>
                <div class="loading-financial-list-wrapper">
                  <FinancialSummary :prize="prize" :isLoading="recalculating" />
                </div>
              </div>
            </div>

            <div
              v-if="!isLanding"
              class="vx-row"
              :class="fixedButton == true ? 'fixed-buttons' : ''"
            >
              <div class="vx-col sm:w-1/2 text-left">
                <vs-button
                  v-if="
                    isQuotationOpen && !isQuotationRefused && canEditAndTransmit
                  "
                  :color="colorButton ? `#${colorButton}` : 'dark'"
                  @click.stop.prevent="cancelChanges()"
                  type="border"
                  class="mt-2 mb-2"
                  data-testId="cancel-button"
                  >Cancelar
                </vs-button>
              </div>
              <div class="vx-col sm:w-1/2 text-right">
                <vs-button
                  v-if="
                    !recalculateProductValues &&
                    isQuotationOpen &&
                    !isQuotationRefused &&
                    canEditAndTransmit
                  "
                  @click.stop.prevent="makeDeal()"
                  type="gradient"
                  color="dark"
                  class="mt-2 mb-2 ml-2"
                  :disabled="
                    invalid ||
                    !isValidRcfValue ||
                    recalculating ||
                    hasZeroKmError ||
                    isWaitingToRecalculate
                  "
                  data-testId="contract-button"
                  >Contratar</vs-button
                >

                <vs-button
                  v-if="
                    !recalculateProductValues &&
                    isQuotationOpen &&
                    !isQuotationRefused &&
                    canEditAndTransmit
                  "
                  :color="colorButton ? `#${colorButton}` : 'success'"
                  @click.stop.prevent="updateQuotation()"
                  type="gradient"
                  class="mt-2 mb-2 ml-2"
                  :disabled="
                    invalid ||
                    !isValidRcfValue ||
                    recalculating ||
                    hasZeroKmError ||
                    isWaitingToRecalculate
                  "
                  data-testId="save-changes-button"
                  >Salvar Alterações</vs-button
                >
              </div>
            </div>
          </div>

          <div class="vx-col w-full text-right">
            <vs-button
              v-if="!isEdition && !isQuotationRefused"
              type="filled"
              @click.stop.prevent="
                !quoatiotionGenerated ? createQuotation() : updateQuotation()
              "
              color="success"
              class="mt-2 mb-2 botaoContratarAgora"
              :class="isLanding ? 'w-full' : ''"
              :pill="isLanding ? true : false"
              data-testId="generate-quotation-button"
              :disabled="(quoatiotionGenerated && invalid) || hasZeroKmError"
            >
              <span>{{
                quoatiotionGenerated ? 'Avançar' : 'Gerar Cotação'
              }}</span>
              <img
                v-if="isLanding"
                src="../../assets/images/svg/iconArrowRight.svg"
              />
            </vs-button>
          </div>
        </div>

        <div v-if="step === 2 && !isEdition">
          <div class="flex flex-col gap-16 lg:gap-18 mb-4">
            <ProductsList
              :products="products"
              :selectedProducts="selectedProducts"
              @update:selectedProducts="updateSelectedProducts"
              @update:isValidRcfValue="updateIsValidRcfValue"
            ></ProductsList>
            <div class="loading-financial-wrapper">
              <div class="loading-financial-list-wrapper">
                <CarregamentosForm
                  :formData="form"
                  :premio="prize.prize_without_discount"
                  :enableDiscount="true"
                  ref="CarregamentosForm"
                  parent="1"
                  @recalcular="calculate()"
                  :brokerId="fieldsWithValidation.brokerId"
                  data-testId="carregamentos-form"
                  :brokerAccountBalanceInsufficient="
                    brokerAccountBalanceInsufficient
                  "
                  :brokerAccountBalanceUsed="brokerAccountBalanceUsed"
                  :nextMonthDiscountMessage="nextMonthDiscountMessage"
                  :shouldValidateDiscount="true"
                  :insuranceCompanyCode="
                    fieldsWithValidation.insuranceCompanyCode
                  "
                />
              </div>
              <div class="loading-financial-list-wrapper">
                <FinancialSummary :prize="prize" :isLoading="recalculating" />
              </div>
            </div>
          </div>
          <div
            v-if="!isLanding"
            class="vx-row"
            :class="fixedButton == true ? 'fixed-buttons' : ''"
          >
            <div class="vx-col sm:w-1/2 text-left">
              <vs-button
                :color="colorButton ? `#${colorButton}` : 'dark'"
                @click.stop.prevent="previous()"
                type="border"
                class="mt-2 mb-2"
                data-testId="previous-button"
                >Voltar
              </vs-button>
            </div>
            <div class="vx-col sm:w-1/2 text-right">
              <vs-button
                v-if="!recalculateProductValues"
                :color="colorButton ? `#${colorButton}` : 'success'"
                @click.stop.prevent="updateQuotation()"
                type="gradient"
                class="mt-2 mb-2"
                :disabled="invalid || !isValidRcfValue"
                data-testId="update-quotation-button"
                >Concluir Cotação</vs-button
              >
            </div>
          </div>
        </div>

        <div
          v-if="
            !isEdition &&
            $can(
              PERMISSIONS_ACTIONS.CHANGE_PROPOSAL_BROKER,
              PERMISSIONS_NAMES.QUOTATIONS,
            ) &&
            step === 0
          "
        >
          <div class="vx-col w-full text-right mt-5">
            <vs-button
              color="success"
              @click="nextStep()"
              data-testId="next-button"
              >Avançar</vs-button
            >
          </div>
        </div>
      </vx-card>

      <Modal
        class="holamundo"
        title="Data de saída da nota fiscal inválida"
        :active.sync="modalInfoDataSaidaNf"
        @close="modalInfoDataSaidaNf = false"
        data-testId="nf-date-invalid-popup"
      >
        A data da nota fiscal deve ser menor ou igual a hoje.
        <div class="vx-row">
          <div class="vx-col w-full text-right">
            <vs-button
              @click="modalInfoDataSaidaNf = false"
              type="gradient"
              color="warning"
              class="mt-5"
              data-testId="nf-date-invalid-understood-button"
            >
              <feather-icon
                class="text-white"
                icon="CheckIcon"
                svgClasses="h-4 w-4"
              ></feather-icon>
              Entendi
            </vs-button>
          </div>
        </div>
      </Modal>

      <Modal
        class="holamundo"
        title="Falha ao recalcular"
        :active="quotationRecalculateFail"
        data-testId="quotation-recalculate-fail-popup"
        button-close-hidden
      >
        Erro ao recalcular
        <div class="vx-row">
          <div class="vx-col w-full text-right">
            <vs-button
              @click="tryRecalculateAgain()"
              type="gradient"
              color="warning"
              class="mt-5"
              data-testId="retry-recalculate-button"
            >
              <feather-icon
                class="text-white"
                icon="CheckIcon"
                svgClasses="h-4 w-4"
              ></feather-icon>
              Tentar novamente
            </vs-button>
          </div>
        </div>
      </Modal>

      <Modal
        class="holamundo"
        title="Cotação Recusada"
        :active.sync="quotationDenied"
        @close="refreshPage()"
        data-testId="quotation-denied-popup"
      >
        {{ proposalResponseReason }}.
        <div class="vx-row">
          <div class="vx-col w-full text-right">
            <vs-button
              @click="refreshPage()"
              type="gradient"
              color="warning"
              class="mt-5"
              data-testId="quotation-denied-close-popup-button"
            >
              <feather-icon
                class="text-white"
                icon="CheckIcon"
                svgClasses="h-4 w-4"
              ></feather-icon>
              Fechar
            </vs-button>
          </div>
        </div>
      </Modal>

      <ModalHistoricoMensageria
        v-if="quotation"
        :active.sync="modalHistoricoMensageria"
        :dadosProposta="{
          idApolice: quotation.id,
          dadosCliente: { idProspect: quotation.prospect.id },
        }"
        @close="closeMessagingModal()"
      />

      <ModalProposalHistory
        v-if="quotation && isEdition && canShowModalLogs"
        :active.sync="modalLogs"
        :proposal-id="Number(id)"
        @close="closeModalLogs()"
        :refresh="refreshHistory"
        @update:refresh="refreshHistory = false"
      />

      <ModalSelectVehicleModel
        :vehicle-model-options="plateApiFipeOptions"
        :reset="resetModalVehicleModel"
        @confirm="setSelectedVehicleModel"
        :active="showSelectPlateModal"
      />
      <ModalPriceChange
        :isOpen.sync="isPriceChangeModalOpen"
        :oldPrice="oldPrice"
        :newPrice="newPrice"
        @confirm="confirmPriceChange"
        @edit="isPriceChangeModalOpen = false"
      />
    </div>
  </ValidationObserver>
</template>
<script>
import ModalProposalHistory from '@/views/modais/ModalProposalHistory.vue';
import ModalSelectVehicleModel from '@/views/modais/ModalSelectVehicleModel.vue';
import jwt from 'jsonwebtoken';
import { Money } from 'v-money';
import {
  ValidationObserver,
  ValidationProvider,
  Validator,
} from 'vee-validate';
import vSelect from 'vue-select';
import Modal from '../../components/Modal.vue';
import {
  DOCUMENT_LENGTH_WITH_MASK,
  DOCUMENT_MASK,
} from '../../constants/cpfCnpj.js';
import { PRICE_CHANGE_THRESHOLD } from '../../constants/executionStages';
import {
  PERMISSIONS_ACTIONS,
  PERMISSIONS_NAMES,
} from '../../constants/permissions.js';
import service from '../../services';
import autoApi from '../../services/auto.api';
import cpfcnpj from '../../services/cpfCnpj.js';
import lifeService from '../../services/life-api.js';
import {
  CONGENERS,
  FUEL_TYPE_CODES,
  FUEL_TYPE_NAMES,
  ID_MOTIVO_RECUSA_CORRETORA_PADRAO,
  LIST_SEXO,
  STATUS_PROPOSTA,
  TIPOS_APOLICES,
  ZERO_KM_VEHICLE_YEAR_ID,
} from '../../utils/constants';
import dateConversion from '../../utils/dateConversion';
import functions from '../../utils/functions';
import notify from '../../utils/notify';
import FinancialSummary from '../lists/financialSummary/FinancialSummary.vue';
import ProductsList from '../lists/products/ProductsList.vue';
import CarregamentosForm from '../menu/nova-cotacao-seguradora/components/carregamentosForm';
import ModalHistoricoMensageria from '../modais/ModalHistoricoMensageria.vue';
import ModalPriceChange from '../modais/quotations/ModalPriceChange.vue';

export default {
  name: 'novaCotacaoAuto',
  props: ['idEmpresaProps', 'isLanding'],
  computed: {
    isQuotationOpen() {
      return (
        this.quotation &&
        this.quotation.status_id === STATUS_PROPOSTA.COTACAO_ABERTA.id
      );
    },
    disableForm() {
      return this.isEdition && !this.canEditAndTransmit;
    },
    canEditAndTransmit() {
      return this.$can(
        PERMISSIONS_ACTIONS.EDIT_AND_TRANSMIT_PROPOSAL,
        PERMISSIONS_NAMES.QUOTATIONS,
      );
    },
    saveOrProceedSuccessMessage() {
      return this.deal
        ? 'Contratado com sucesso'
        : 'Alterações salvas com sucesso';
    },
    saveOrProceedErrorMessage() {
      return this.deal
        ? 'Erro ao contratar. Tente novamente'
        : 'Erro ao salvar alterações. Tente novamente';
    },
    isMobile() {
      return this.windowWidth <= 768;
    },
    isEdition() {
      return this.id !== null;
    },
    isQuotationRefused() {
      return (
        this.quotation &&
        [
          STATUS_PROPOSTA.COTACAO_RECUSADA.id,
          STATUS_PROPOSTA.COTACAO_CANCELADA.id,
        ].includes(this.quotation.status_id)
      );
    },
    hasPdf() {
      if (this.quotationPdf) {
        return true;
      }
      if (this.proposalPdf) {
        return true;
      }
      return !!this.policyPdf;
    },
    getCreatedAt() {
      if (!this.quotation || !this.isEdition) {
        return '';
      }

      return functions.formataDataHoraPadraoBR(
        this.quotation.created_at,
        false,
      );
    },
    isCanceled() {
      if (!this.isEdition) {
        return false;
      }

      if (!this.quotation) {
        return false;
      }

      return [
        STATUS_PROPOSTA.COTACAO_CANCELADA.id,
        STATUS_PROPOSTA.COTACAO_RECUSADA.id,
      ].includes(this.quotation.status_id);
    },
    showPlate() {
      return !this.isBrandNew;
    },
    hasCepApiReturned() {
      return !!this.cepApiResult;
    },
    isPerson() {
      return (
        this.fieldsWithValidation.cpfcnpj.length <=
        this.DOCUMENT_LENGTH_WITH_MASK.CPF
      );
    },
    permissaoRecusaCorretora() {
      return this.$can(
        PERMISSIONS_ACTIONS.REJECT_BROKER,
        PERMISSIONS_NAMES.QUOTATIONS,
      );
    },
    isRenovationByCNSeg() {
      return (
        this.fieldsWithValidation.insuranceCompanyCode &&
        this.insuranceCompanies.find(
          (company) =>
            company.id === this.fieldsWithValidation.insuranceCompanyCode,
        ) &&
        ![CONGENERS.NOT_RENEWAL.id, CONGENERS.OTHER.id].includes(
          this.fieldsWithValidation.insuranceCompanyCode,
        )
      );
    },
    plateApiFipeOptions() {
      if (!this.vehicleResult) {
        return [];
      }
      return this.vehicleResult.fipe_data;
    },
    nextMonthDiscountMessage() {
      if (!this.quotation) {
        return '';
      }

      const quotationDateString = this.quotation.created_at;
      if (!quotationDateString) {
        return '';
      }
      const now = new Date();
      const quotationDate = new Date(quotationDateString);
      const isSameMonth = now.getMonth() === quotationDate.getMonth();
      if (isSameMonth) {
        return '';
      }
      return 'Alterações impactarão saldo atual';
    },
    hasZeroKmError() {
      return (
        this.isBrandNew &&
        this.fieldsWithValidation.fipeResult &&
        this.fieldsWithValidation.fipeResult.amount === 'R$ 0,00'
      );
    },
    canShowModalLogs() {
      return this.$can(
        PERMISSIONS_ACTIONS.SHOW_ALTERATIONS_HISTORY,
        PERMISSIONS_NAMES.QUOTATIONS,
      );
    },
  },
  watch: {
    fieldsWithValidation: {
      handler() {
        if (!this.quoatiotionGenerated) return;
        this.isWaitingToRecalculate = true;
        this.validateForm();
        this.recalculateWithDebounce();
      },
      deep: true,
    },
    isRenovationByCNSeg(newValue) {
      if (newValue === false) {
        this.fieldsWithValidation.bonus = 0;
      }
    },
    'fieldsWithValidation.insuranceCompanyCode'() {
      this.getCongeners();
    },
    'fieldsWithValidation.cpfcnpj'() {
      if (this.insuredIsMainDriver) {
        this.driverCpfCnpj = this.fieldsWithValidation.cpfcnpj;
      }
      if (
        this.fieldsWithValidation.cpfcnpj.length ===
        this.DOCUMENT_LENGTH_WITH_MASK.CNPJ
      ) {
        this.socialName = false;
        this.fieldsWithValidation.civilName = '';

        if (this.insuredIsMainDriver) {
          this.insuredIsMainDriver = false;
          this.clearDriverData();
        }
      }
    },
    driverCpfCnpj() {
      if (this.fieldsWithValidation.cpfcnpj === this.driverCpfCnpj) {
        this.insuredIsMainDriver = true;
      }

      if (!this.quoatiotionGenerated) return;
      this.isWaitingToRecalculate = true;
      this.recalculateWithDebounce();
    },
    'fieldsWithValidation.name'() {
      if (this.insuredIsMainDriver) {
        this.fieldsWithValidation.driverName = this.fieldsWithValidation.name;
      }
    },
    socialName() {
      if (this.insuredIsMainDriver) {
        this.driverSocialName = this.socialName;
      }
    },
    'fieldsWithValidation.civilName'() {
      if (this.insuredIsMainDriver) {
        this.fieldsWithValidation.driverCivilName =
          this.fieldsWithValidation.civilName;
      }
    },
    'fieldsWithValidation.driverBirthdate'() {
      if (this.insuredIsMainDriver) {
        this.birthDate = this.fieldsWithValidation.driverBirthdate;
      }
    },
    'fieldsWithValidation.driverGender'() {
      if (this.insuredIsMainDriver) {
        this.gender = this.fieldsWithValidation.driverGender;
      }
    },
    discount() {
      this.recalculateProductValues = true;
    },
    selectedProducts() {
      if (this.isValidRcfValue) {
        this.calculate();
      }
    },
    insuredIsMainDriver() {
      if (this.insuredIsMainDriver) {
        this.driverCpfCnpj = this.fieldsWithValidation.cpfcnpj;
        this.fieldsWithValidation.driverName = this.fieldsWithValidation.name;
        this.driverSocialName = this.socialName;
        this.fieldsWithValidation.driverCivilName =
          this.fieldsWithValidation.civilName;
        this.fieldsWithValidation.driverGender = this.gender;
        this.fieldsWithValidation.driverBirthdate = this.birthDate;
      } else {
        this.driverCpfCnpj = '';
        this.fieldsWithValidation.driverName = '';
        this.driverSocialName = false;
        this.fieldsWithValidation.driverCivilName = '';
        this.fieldsWithValidation.driverBirthdate = '';
        this.fieldsWithValidation.driverGender = '';
        this.gender = '';
        this.birthDate = '';
      }
    },
  },
  data() {
    return {
      PERMISSIONS_ACTIONS,
      PERMISSIONS_NAMES,
      DOCUMENT_MASK,
      DOCUMENT_LENGTH_WITH_MASK,
      fieldsWithValidation: {
        brokerId: null,
        insuranceCompanyCode: null,
        bonus: null,
        cpfcnpj: '',
        name: '',
        civilName: '',
        driverBirthdate: null,
        driverGender: null,
        driverName: '',
        driverCivilName: '',
        overnightZipCode: '',
        overnightStreet: null,
        overnightNeighborhood: null,
        overnightCity: null,
        overnightState: null,
        overnightNumber: null,
        overnightComplement: null,
        vehiclePlate: '',
        vehicleChassis: '',
        vehicleBrandId: null,
        vehicleModelId: null,
        vehicleYearModel: null,
        fipeResult: null,
        increasesAnswers: {},
      },
      recalculating: false,
      isValidRcfValue: true,
      STATUS_PROPOSTA,
      windowWidth: window.innerWidth,
      id: null,
      deal: false,
      key: null,
      quotationDenied: false,
      proposalResponseReason: null,
      quotationRecalculateFail: false,
      policyTypes: TIPOS_APOLICES,
      modalLogs: false,
      refreshHistory: false,
      logsAlteracoes: [],
      colorButton: this.$route.query.colorButton,
      fixedButton: this.$route.query.fixedesabilitaAlterarMarcaButton,
      LIST_SEXO,
      money: {
        decimal: ',',
        thousands: '.',
        prefix: 'R$ ',
        suffix: '',
        precision: 2,
        masked: true,
      },
      showPanel: this.$route.query.showPanel,
      hideLogo: this.$route.query.hideLogo,
      logo: '',
      step: 0,
      brokers: [],
      coverages: [],
      insuranceCompanies: [],
      bonuses: [
        {
          id: 1,
          label: 'Não',
        },
        {
          id: 2,
          label: 'Sim, renovação da BP Seguradora',
        },
        {
          id: 3,
          label: 'Sim, renovação de outra seguradora afiliada à CNSEG',
        },
        {
          id: 4,
          label: 'Sim, renovação de outra segurado não afiliada à CNSEG',
        },
      ],
      isRenovation: null,
      policyNumber: null,
      bonusesLevel: [
        {
          id: 0,
          label: 0,
        },
        {
          id: 1,
          label: 1,
        },
        {
          id: 2,
          label: 2,
        },
        {
          id: 3,
          label: 3,
        },
        {
          id: 4,
          label: 4,
        },
        {
          id: 5,
          label: 5,
        },
        {
          id: 6,
          label: 6,
        },
        {
          id: 7,
          label: 7,
        },
        {
          id: 8,
          label: 8,
        },
        {
          id: 9,
          label: 9,
        },
        {
          id: 10,
          label: 10,
        },
      ],
      socialName: false,
      birthDate: '',
      gender: '',
      insuredIsMainDriver: false,
      driverCpfCnpj: '',
      driverSocialName: false,
      estados: [],
      cidades: [],
      isBrandNew: false,
      searchingPlate: false,
      searchingChassi: false,
      vehicleInvoiceNumber: null,
      vehicleInvoiceDate: '',
      vehicleIsOutOfDaelership: null,
      filledManually: false,
      vehicleTypeId: {
        id: 1,
        label: 'Carro',
      },
      vehicleFuelId: null,
      selectedCoverage: null,
      vehicleBrand: null,
      vehicleModel: null,
      vehicleYearFactory: null,
      vehicleFipeCode: null,
      vehicleColor: null,
      vehiclePorts: null,
      vehicleEngineNumber: null,
      vehicleRenavam: null,
      vehicleCylinderCapacity: null,
      vehicleFuel: null,
      vehiclePassengerQuantity: null,
      modalInfoDataSaidaNf: false,
      placaEncontrada: false,
      vehicleTypes: [],
      vehicleBrands: [],
      vehicleModels: [],
      vehicleYearsModel: [],
      increases: [],
      zipCodeIncreases: null,
      increasesOldFormat: [],
      vehicleResult: null,
      fuelCode: {
        G: 1,
        A: 2,
        D: 3,
        E: 4,
        F: 5,
        H: 6,
      },
      mostrarMaisModelosEncontrados: false,
      selectedFipeModel: null,
      quotation: null,
      prize: null,
      quoatiotionGenerated: false,
      products: [],
      selectedProducts: [],
      form: {
        carregamentos: {
          'Despesa ADM': { porcentagem: 0 },
          'Margem de Lucro': { porcentagem: 0 },
          Corretagem: { porcentagem: 0 },
          Estipulante: { porcentagem: 0 },
        },
        desconto: 0,
      },
      recalculateProductValues: false,
      discount: 0,
      modalBrokerAccoutBalance: false,
      brokerAccountConfigs: null,
      modalHistoricoMensageria: false,
      quotationPdf: null,
      proposalPdf: null,
      policyPdf: null,
      proposalDate: null,
      subscriptionDate: null,
      listAllowedStates: [],
      maxRcfCoverageValue: null,
      cepApiResult: false,
      resetModalVehicleModel: false,
      showSelectPlateModal: false,
      hasCepApiReturnedOvernightStreet: true,
      hasCepApiReturnedOvernightNeighborhood: true,
      hasCepApiReturnedOvernightState: true,
      hasCepApiReturnedOvernightCity: true,
      brokerAccountBalanceInsufficient: false,
      brokerAccountBalanceUsed: false,
      isPriceChangeModalOpen: false,
      oldPrice: 0,
      newPrice: 0,
      continueQuotation: false,
      isWaitingToRecalculate: false,
    };
  },
  methods: {
    validateForm() {
      this.$nextTick(() => {
        this.$refs.newQuotationForm.validate();
      });
    },
    getVehicleYearModelLabel(vehicleYearModel) {
      return `${vehicleYearModel.year_model} ${vehicleYearModel.fuel}`;
    },
    createDynamicValidations() {
      Validator.extend('estado_pernoite', {
        getMessage: () =>
          `Pernoite deve ser em ${this.listAllowedStates.join(', ')}.`,
        validate: (value) => {
          return this.listAllowedStates.includes(value.toUpperCase());
        },
      });
    },
    createValidations() {
      Validator.extend('min_age', {
        getMessage: () => `Você deve ter pelo menos 18 anos.`,
        validate: (value) => {
          let [day, month, year] = value.split('/');
          let birthDate = new Date(year, month - 1, day, 0, 0, 0);
          let today = new Date();
          let age = today.getFullYear() - birthDate.getFullYear();
          let m = today.getMonth() - birthDate.getMonth();
          if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
            age--;
          }
          return age >= 18;
        },
      });
      Validator.extend('max_age', {
        getMessage: () => `Você deve ter pelo menos 100 anos.`,
        validate: (value) => {
          let [day, month, year] = value.split('/');
          let birthDate = new Date(year, month - 1, day, 0, 0, 0);
          let today = new Date();
          let age = today.getFullYear() - birthDate.getFullYear();
          let m = today.getMonth() - birthDate.getMonth();
          if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
            age--;
          }
          return age <= 100;
        },
      });
      Validator.extend('less_than_today', {
        getMessage: () => `A data deve ser menor ou igual a hoje.`,
        validate: (value) => {
          let [day, month, year] = value.split('/');
          let dateNf = new Date(year, month - 1, day, 0, 0, 0);
          let today = new Date();
          return dateNf <= today;
        },
      });
      Validator.extend('min_30days', {
        getMessage: () => `Não deve ser inferior a 30 dias.`,
        validate: (value) => {
          let [day, month, year] = value.split('/');
          let dateNf = new Date(year, month - 1, day, 0, 0, 0);
          let today = new Date();
          today.setHours(0, 0, 0, 0);

          let minDate = new Date(today);
          minDate.setDate(minDate.getDate() - 30);

          return dateNf >= minDate;
        },
      });
      Validator.extend('cpf_cnpj', {
        getMessage: (field) =>
          `O campo ${field} deve ser um CPF ou CNPJ válido.`,
        validate: (value) => {
          return cpfcnpj.valida_cpf_cnpj(value);
        },
      });
      Validator.extend('nome', {
        getMessage: (field) =>
          `O campo ${field} deve ser um ${
            field === 'CEP' ? field : 'Nome'
          } válido.`,
        validate: (value) => {
          return functions.nameValidate(value, this.isPerson);
        },
      });
      Validator.extend('is-person-name', {
        getMessage: (field) => `O campo ${field} deve ser um Nome válido.`,
        validate: (value) => {
          return functions.nameValidate(value, true);
        },
      });
    },
    updateSelectedSliderProduct(productChanged) {
      this.selectedProducts = this.selectedProducts.map((product) =>
        product.id === productChanged.id
          ? { ...product, quantity: productChanged.quantity }
          : product,
      );
      const alreadyInSelected = this.selectedProducts.find(
        (product) => product.id === productChanged.id,
      );
      if (!alreadyInSelected) {
        this.selectedProducts.push({
          id: productChanged.id,
          quantity: productChanged.quantity,
        });
      }
    },
    updateSelectedSelectProduct(productChanged) {
      const productChangedGroupingIds = this.products
        .filter((product) => product.grouping === productChanged.grouping)
        .map((product) => product.id);

      this.selectedProducts = this.selectedProducts.map((product) =>
        productChangedGroupingIds.includes(product.id)
          ? { ...product, id: productChanged.id }
          : product,
      );
    },
    updateSelectedProducts(productChanged) {
      if (productChanged.input === 'slider') {
        this.updateSelectedSliderProduct(productChanged);
        return;
      }
      this.updateSelectedSelectProduct(productChanged);
    },
    updateIsValidRcfValue(isValidRcfValue) {
      if (this.isValidRcfValue === isValidRcfValue) return;
      this.isValidRcfValue = isValidRcfValue;
      if (!isValidRcfValue) {
        notify.notifyFail(
          this.$vs,
          `Soma dos RCFs não deve ultrapassar R$ ${
            this.maxRcfCoverageValue / 1000
          } mil`,
        );
      }
    },
    validaterequiredPlate() {
      const isQuotation = Boolean(this.$route.params.id);
      return {
        valid: !isQuotation || this.fieldsWithValidation.vehiclePlate !== '',
        message: 'O campo Placa é obrigatório',
      };
    },
    validaterequiredChassis() {
      const isQuotation = Boolean(this.$route.params.id);
      return {
        valid: !isQuotation || this.fieldsWithValidation.vehicleChassis !== '',
        message: 'O campo Chassi é obrigatório',
      };
    },
    clearAllVehicleData() {
      this.fieldsWithValidation.vehiclePlate = '';
      this.clearVehicleData();
    },
    clearVehicleData() {
      this.fieldsWithValidation.vehicleChassis = '';
      this.clearVehicleDataWithOutChassi();
    },
    clearVehicleDataWithOutChassi() {
      this.vehicleTypeId = {
        id: 1,
        label: 'Carro',
      };
      this.vehicleResult = null;
      this.selectedFipeModel = null;
      this.fieldsWithValidation.vehicleBrandId = null;
      this.fieldsWithValidation.vehicleModelId = null;
      this.vehicleFuelId = null;
      this.fieldsWithValidation.vehicleYearModel = null;
      this.vehicleBrand = null;
      this.vehicleModel = null;
      this.vehicleYearFactory = null;
      this.vehicleFipeCode = null;
      this.vehicleColor = null;
      this.vehicleEngineNumber = null;
      this.vehicleRenavam = null;
      this.vehicleCylinderCapacity = null;
      this.vehicleFuel = null;
      this.vehiclePassengerQuantity = null;
      this.fieldsWithValidation.fipeResult = null;
      this.coverages = [];
      this.selectedCoverage = null;
    },
    updateWidth() {
      this.windowWidth = window.innerWidth;
    },
    filterOptions(options, search) {
      const filtered = options.filter((option) => {
        return (
          option.label.toLowerCase().includes(search.toLowerCase()) ||
          option.label === 'Sim, outra seguradora'
        );
      });

      return filtered;
    },
    getSelectedCongenerLabel(item) {
      const congener = this.insuranceCompanies.find((company) => {
        return company.id === item.id;
      });
      if (congener) {
        return congener.label;
      }
      return item.id === CONGENERS.NOT_RENEWAL.id
        ? CONGENERS.NOT_RENEWAL.label
        : CONGENERS.OTHER.label;
    },
    openModalHistoricoMensageria() {
      this.modalHistoricoMensageria = true;
    },
    getLabelContrato() {
      if (this.subscriptionDate) {
        return 'Apólice';
      }
      if (this.proposalDate) {
        return 'Proposta';
      }
      return 'Cotação';
    },
    openPdf() {
      if (this.quotationPdf || this.proposalPdf || this.policyPdf) {
        let link = null;
        switch (this.getLabelContrato()) {
          case 'Apólice':
            link = this.policyPdf;
            break;
          case 'Proposta':
            link = this.proposalPdf;
            break;
          case 'Cotação':
            link = this.quotationPdf;
            break;
          default:
            link = this.proposalPdf;
        }
        window.open(link, '_blank');
      } else if (this.subscriptionDate || this.proposalDate) {
        window.open(`/contratoProposta/${this.key}`, '_blank');
      } else {
        window.open(`/contratoCotacao/${this.key}`, '_blank');
      }
    },
    previous() {
      this.form.desconto = 0;
      this.step--;
    },
    recalculate() {
      if (this.isEdition) {
        this.calculate();
      }
    },
    canRecalculateWithCurrentData() {
      const { fieldsWithValidation } = this;
      const driverName = (fieldsWithValidation.driverName || '').trim();
      const hasValidDriverData =
        cpfcnpj.valida_cpf_cnpj(this.driverCpfCnpj) &&
        functions.nameValidate(driverName) &&
        Boolean(fieldsWithValidation.driverGender) &&
        fieldsWithValidation.driverBirthdate !== null &&
        fieldsWithValidation.driverBirthdate !== undefined &&
        fieldsWithValidation.driverBirthdate !== '';
      const hasOpenQuotation =
        this.quotation &&
        this.quotation.status_id === STATUS_PROPOSTA.COTACAO_ABERTA.id;
      const hasValidFipeResult =
        fieldsWithValidation.fipeResult &&
        fieldsWithValidation.fipeResult.amount !== null &&
        fieldsWithValidation.fipeResult.amount !== undefined &&
        fieldsWithValidation.fipeResult.amount !== '';

      const requiredChecks = [
        this.isEdition,
        hasOpenQuotation,
        fieldsWithValidation.overnightZipCode.length === 10,
        cpfcnpj.valida_cpf_cnpj(fieldsWithValidation.cpfcnpj),
        hasValidDriverData,
        hasValidFipeResult,
        !this.hasZeroKmError,
        Boolean(
          fieldsWithValidation.vehicleYearModel &&
            fieldsWithValidation.vehicleYearModel.year,
        ),
        Boolean(this.vehicleTypeId && this.vehicleTypeId.id),
      ];

      return requiredChecks.every(Boolean);
    },
    recalculateWithDebounce: functions.debounce(function () {
      if (!this.canRecalculateWithCurrentData()) {
        return;
      }

      this.calculate();
      this.isWaitingToRecalculate = false;
    }, 1000),
    tryRecalculateAgain() {
      this.quotationRecalculateFail = false;
      this.calculate();
    },
    calculate(validate = false) {
      if (
        !this.quotation ||
        this.quotation.status_id != STATUS_PROPOSTA.COTACAO_ABERTA.id
      ) {
        return;
      }

      if (validate) {
        this.$vs.loading();
      }

      const payload = this.getBasePayload();
      const updatePayload = this.getUpdatePayload();

      this.recalculating = true;
      autoApi
        .recalculate(
          this.quotation.id,
          { ...payload, ...updatePayload },
          validate,
        )
        .then((res) => {
          this.prize = res.prize;
          this.products = res.all_coverages.details;
          this.recalculateProductValues = false;
          this.quotationRecalculateFail = false;
          if (validate) {
            this.step++;
          }
        })
        .catch((error) => {
          if (error.response && error.response.status === 422) {
            this.quotationDenied = true;
            const raw = error.response.data.message || '';
            let displayMessage = raw;
            try {
              const parsed = JSON.parse(raw);
              if (parsed && parsed.text) displayMessage = parsed.text;
            } catch (error) {
              displayMessage = raw;
            }
            if (displayMessage) this.proposalResponseReason = displayMessage;
            return;
          }

          this.quotationRecalculateFail = true;
        })
        .finally(() => {
          this.recalculating = false;
          if (validate) {
            this.$vs.loading.close();
          }
        });
    },
    makeDeal() {
      const validRequerid = this.isBrandNew
        ? this.validaterequiredChassis()
        : this.validaterequiredPlate();

      if (!validRequerid.valid) {
        notify.notifyFail(this.$vs, validRequerid.message);
        return;
      }

      this.deal = true;

      this.updateQuotation();
    },
    updateQuotation() {
      const totalPrize = this.prize.prize;
      const tariffPrize = this.prize.tariff_prize;

      const payload = this.getBasePayload();
      const updatePayload = this.getUpdatePayload();

      if (this.deal) {
        updatePayload.proposal_status = STATUS_PROPOSTA.EM_TRANSMISSAO.id;
      }

      this.$vs.loading();

      autoApi
        .update(this.quotation.id, { ...payload, ...updatePayload })
        .then((res) => {
          this.quotation = res;
          this.prize = res.prize;

          if (this.step === 1 && !this.isEdition) {
            this.quoatiotionGenerated = true;
            this.products = this.quotation.all_coverages.details;
            this.setDefaultSelectedProducts();
            this.step++;
            return;
          }

          const hasSignificantPriceChange =
            Math.abs(tariffPrize - this.prize.tariff_prize) >=
            PRICE_CHANGE_THRESHOLD;
          if (hasSignificantPriceChange && this.deal) {
            this.handlePriceChange(totalPrize, this.prize.prize);
            this.deal = false;
            this.$vs.loading.close();
            return;
          }
          this.$vs.loading.close();

          this.recalculateProductValues = false;

          notify.notifySuccess(this.$vs, this.saveOrProceedSuccessMessage);

          if (!this.isEdition) {
            window.location.href = `/auto/cotacao/${this.quotation.proposal_id}`;
          }

          if (this.isEdition && !this.deal) {
            this.brokerAccountBalanceUsed = !this.brokerAccountBalanceUsed;
          }

          if (this.deal) {
            window.location.href = `/auto/proposta/${this.quotation.proposal_id}`;
          }

          this.quotationPdf = res.quotation_pdf;
          this.proposalPdf = res.proposal_pdf;
          this.policyPdf = res.policy_pdf;
        })
        .catch((error) => {
          this.$vs.loading.close();
          if (error.response && error.response.status === 422) {
            this.quotationDenied = true;
            const raw = error.response.data.message || '';
            let displayMessage = raw;
            try {
              const parsed = JSON.parse(raw);
              if (parsed && parsed.text) displayMessage = parsed.text;
            } catch (error) {
              displayMessage = raw;
            }
            if (displayMessage) this.proposalResponseReason = displayMessage;
            return;
          }

          if (error.response && error.response.status === 503) {
            notify.notifyFail(this.$vs, error.response.data.message);
            return;
          }

          this.brokerAccountBalanceInsufficient =
            !this.brokerAccountBalanceInsufficient;
          this.deal = false;

          if (
            error.response &&
            error.response.data &&
            error.response.data.message
          ) {
            notify.notifyFail(this.$vs, error.response.data.message);
            return;
          }

          notify.notifyFail(this.$vs, this.saveOrProceedErrorMessage);
        })
        .finally(() => {
          this.refreshHistory = true;
        });
    },
    handlePriceChange(oldPrice, newPrice) {
      this.oldPrice = oldPrice;
      this.newPrice = newPrice;
      this.isPriceChangeModalOpen = true;
    },
    confirmPriceChange() {
      this.isPriceChangeModalOpen = false;
      this.deal = true;
      this.updateQuotation();
    },
    refreshPage() {
      this.quotationDenied = false;
      this.proposalResponseReason = null;
      window.location.href = '/Cotacoes';
    },
    setDefaultSelectedProducts() {
      this.selectedProducts = this.products
        .filter(
          (product) => Boolean(product.mandatory) || product.input === 'slider',
        )
        .map((product) => {
          return {
            id: product.id,
            quantity:
              product.input === 'slider' ? Number(product.defaultLmi) : 1,
          };
        });
    },
    createQuotation() {
      this.$refs.newQuotationForm.validate().then((result) => {
        if (result) {
          const payload = this.getBasePayload();

          this.$vs.loading();

          autoApi
            .createQuotation(payload)
            .then((res) => {
              this.quotation = res;
              this.prize = res.prize;
              this.quoatiotionGenerated = true;
              this.products = this.quotation.all_coverages.details;
              this.setDefaultSelectedProducts();

              this.step++;
              this.$vs.loading.close();
            })
            .catch((error) => {
              this.$vs.loading.close();

              if (error.response && error.response.status === 422) {
                this.quotationDenied = true;
                const raw = error.response.data.message || '';
                let displayMessage = raw;
                try {
                  const parsed = JSON.parse(raw);
                  if (parsed && parsed.text) displayMessage = parsed.text;
                } catch (error) {
                  displayMessage = raw;
                }
                if (displayMessage)
                  this.proposalResponseReason = displayMessage;
                return;
              }

              if (error.response && error.response.status === 503) {
                notify.notifyFail(this.$vs, error.response.data.message);
                return;
              }

              this.brokerAccountBalanceInsufficient =
                !this.brokerAccountBalanceInsufficient;

              notify.notifyFail(this.$vs, 'Não foi possível criar a cotação');
            });
        }
      });
    },
    getBasePayload() {
      const formatedIncreases = [];

      for (let id of Object.keys(this.fieldsWithValidation.increasesAnswers)) {
        formatedIncreases.push({
          id: Number(id),
          answers: this.fieldsWithValidation.increasesAnswers[id].id,
        });
      }

      const [day, month, year] = this.fieldsWithValidation.driverBirthdate
        .split('/')
        .map(Number);
      const driverBirthdate = new Date(year, month - 1, day, 0, 0, 0);

      let insuredBirthdate = null;
      if (this.birthDate) {
        const [day, month, year] = this.birthDate.split('/').map(Number);
        insuredBirthdate = new Date(
          year,
          month - 1,
          day,
          0,
          0,
          0,
        ).toISOString();
      }

      let dateNf = null;

      if (this.vehicleInvoiceDate) {
        const [dayNf, monthNf, yearNf] = this.vehicleInvoiceDate
          .split('/')
          .map(Number);
        dateNf = new Date(yearNf, monthNf - 1, dayNf, 0, 0, 0);
      }

      return {
        broker_id: this.fieldsWithValidation.brokerId,
        prospect: {
          tax_id: this.fieldsWithValidation.cpfcnpj,
          name: this.fieldsWithValidation.name,
          social_name: this.socialName,
          civil_name: this.fieldsWithValidation.civilName,
          gender: this.gender,
          birthdate: insuredBirthdate,
        },
        driver: {
          tax_id: this.driverCpfCnpj,
          name: this.fieldsWithValidation.driverName,
          social_name: this.driverSocialName,
          civil_name: this.fieldsWithValidation.driverCivilName,
          gender: this.fieldsWithValidation.driverGender,
          birthdate: driverBirthdate.toISOString(),
        },
        overnight_address: {
          zip_code: this.fieldsWithValidation.overnightZipCode.replace('.', ''),
          street: this.fieldsWithValidation.overnightStreet,
          neighborhood: this.fieldsWithValidation.overnightNeighborhood,
          city: this.fieldsWithValidation.overnightCity,
          state: this.fieldsWithValidation.overnightState,
          number: this.fieldsWithValidation.overnightNumber,
          complement: this.fieldsWithValidation.overnightComplement,
          is_cep_api_result: this.cepApiResult,
        },
        addition_information: {
          is_renovation: this.fieldsWithValidation.insuranceCompanyCode != '1',
          bonus: this.fieldsWithValidation.bonus || 0,
          policy_number: this.policyNumber,
          insurance_company_code:
            this.fieldsWithValidation.insuranceCompanyCode,
        },
        vehicle: {
          type_id: Number(this.vehicleTypeId.id),
          brand_id: this.fieldsWithValidation.vehicleBrandId
            ? Number(this.fieldsWithValidation.vehicleBrandId.id)
            : null,
          model_id: this.fieldsWithValidation.vehicleModelId
            ? Number(this.fieldsWithValidation.vehicleModelId.id)
            : null,
          plate: this.fieldsWithValidation.vehiclePlate,
          chassis: this.fieldsWithValidation.vehicleChassis,
          coverageValue:
            typeof this.fieldsWithValidation.fipeResult.amount === 'string'
              ? Number(
                  this.fieldsWithValidation.fipeResult.amount
                    .replace('R$ ', '')
                    .replace('.', '')
                    .replace(',', '.'),
                )
              : this.fieldsWithValidation.fipeResult.amount,
          is_brand_new: this.isBrandNew,
          invoice_number: this.vehicleInvoiceNumber,
          invoice_date: !this.vehicleInvoiceDate
            ? null
            : functions.formataDataHoraPadraoBR(dateNf.toISOString(), false),
          out_daelership: this.vehicleIsOutOfDaelership,
          brand:
            this.vehicleBrand || this.fieldsWithValidation.fipeResult.brand,
          model:
            this.vehicleModel || this.fieldsWithValidation.fipeResult.model,
          year_model: Number(this.fieldsWithValidation.vehicleYearModel.year),
          year_factory: Number(this.vehicleYearFactory),
          fipe_code:
            this.vehicleFipeCode ||
            this.fieldsWithValidation.fipeResult.fipe_code,
          color: this.vehicleColor,
          ports: this.vehiclePorts,
          engine_number: this.vehicleEngineNumber,
          renavam: this.vehicleRenavam,
          cylinder_capacity: Number(this.vehicleCylinderCapacity),
          fuel: this.vehicleFuel || this.fieldsWithValidation.fipeResult.fuel,
          passenger_quantity: this.vehiclePassengerQuantity,
          plate_result: this.vehicleResult
            ? JSON.stringify(this.vehicleResult)
            : null,
          fipe_result: this.fieldsWithValidation.fipeResult
            ? JSON.stringify(this.fieldsWithValidation.fipeResult)
            : null,
          filled_manually: this.filledManually,
        },
        increases: formatedIncreases,
      };
    },
    getNonZeroProducts() {
      return [...this.selectedProducts].filter(
        (product) => product.quantity !== 0,
      );
    },
    parseDiscountValue() {
      if (!this.form.desconto) return 0;

      if (typeof this.form.desconto === 'string') {
        const cleanString = this.form.desconto
          .replace('R$ ', '')
          .replace('.', '')
          .replace(',', '.');
        return Number(cleanString);
      }

      if (typeof this.form.desconto === 'number') {
        return this.form.desconto;
      }

      return 0;
    },
    getUpdatePayload() {
      const formatedCharges = [];
      for (let carregamento of Object.keys(this.form.carregamentos)) {
        const charge = this.form.carregamentos[carregamento];
        formatedCharges.push({
          id: charge.idCarregamento,
          percentage: Number(charge.porcentagem),
        });
      }

      return {
        id: this.quotation.id,
        charges: formatedCharges,
        coverage_products: this.getNonZeroProducts(),
        discount: this.parseDiscountValue(),
      };
    },
    getBrokerAccountConfigs() {
      autoApi
        .getBrokerAccountConfigs()
        .then((res) => {
          this.brokerAccountConfigs = res;
          this.form.maximoDesconto = this.brokerAccountConfigs;
        })
        .catch(() => {
          notify.notifyFail(
            this.$vs,
            'Não foi possível buscar as configurações da conta corrente',
          );
        });
    },
    getBrokers() {
      autoApi
        .getBrokers()
        .then((res) => {
          this.brokers = res;
        })
        .catch(() => {
          notify.notifyFail(this.$vs, 'Erro ao buscar as corretoras');
        });
    },
    getQuotation() {
      autoApi
        .getQuotation(this.id)
        .then((res) => {
          this.quotation = res;
          this.fieldsWithValidation.brokerId = res.broker.id;

          this.isRenovation = res.addition_information.is_renovation;
          this.fieldsWithValidation.insuranceCompanyCode =
            res.addition_information.insurance_company_code;
          this.policyNumber = res.addition_information.policy_number;
          this.fieldsWithValidation.bonus = res.addition_information.bonus;

          this.fieldsWithValidation.cpfcnpj = res.prospect.tax_id;
          this.fieldsWithValidation.name = res.prospect.name;
          this.socialName = res.prospect.social_name;
          this.fieldsWithValidation.civilName = res.prospect.civil_name;
          this.birthDate = res.prospect.birthdate
            ? dateConversion.convertISOToDate(res.prospect.birthdate)
            : null;
          this.gender = res.prospect.gender;
          this.quotationPdf = res.quotation_pdf;
          this.proposalPdf = res.proposal_pdf;
          this.policyPdf = res.policy_pdf;
          this.proposalDate = res.proposal_date;
          this.subscriptionDate = res.subscription_date;
          this.key = res.key;

          this.insuredIsMainDriver = res.prospect.tax_id === res.driver.tax_id;
          this.driverCpfCnpj = res.driver.tax_id;
          this.fieldsWithValidation.driverName = res.driver.name;
          this.driverSocialName = res.driver.social_name;
          this.fieldsWithValidation.driverCivilName = res.driver.civil_name;
          this.fieldsWithValidation.driverGender = res.driver.gender;
          this.fieldsWithValidation.driverBirthdate =
            dateConversion.convertISOToDate(res.driver.birthdate);

          this.fieldsWithValidation.overnightZipCode =
            res.overnight_address.zip_code;
          this.fieldsWithValidation.overnightStreet =
            res.overnight_address.street;
          this.fieldsWithValidation.overnightNeighborhood =
            res.overnight_address.neighborhood;
          this.fieldsWithValidation.overnightCity = res.overnight_address.city;
          this.fieldsWithValidation.overnightState =
            res.overnight_address.state;
          this.fieldsWithValidation.overnightNumber =
            res.overnight_address.number;
          this.fieldsWithValidation.overnightComplement =
            res.overnight_address.complement;
          this.cepApiResult = res.overnight_address.is_cep_api_result;

          this.vehicleTypeId = this.vehicleTypes.find(
            (vehicleType) => vehicleType.id === res.vehicle.type_id,
          );
          this.fieldsWithValidation.vehicleBrandId = {
            id: res.vehicle.brand_id,
            label: res.vehicle.brand,
          };
          this.fieldsWithValidation.vehicleModelId = {
            id: res.vehicle.model_id,
            label: res.vehicle.model,
          };
          const yearModelLabel = this.getVehicleYearModelLabel(res.vehicle);
          this.fieldsWithValidation.vehicleYearModel = {
            id: yearModelLabel,
            label: yearModelLabel,
            fuel: res.vehicle.fuel,
            year: res.vehicle.year_model,
          };

          this.fieldsWithValidation.vehiclePlate = res.vehicle.plate;
          this.fieldsWithValidation.vehicleChassis = res.vehicle.chassis;

          this.isBrandNew = res.vehicle.is_brand_new;
          this.vehicleInvoiceDate = res.vehicle.invoice_date;
          this.vehicleIsOutOfDaelership = res.vehicle.out_daelership;
          this.vehicleInvoiceNumber = res.vehicle.invoice_number;

          this.vehicleBrand = res.vehicle.brand;
          this.vehicleModel = res.vehicle.model;
          this.vehicleYearFactory = res.vehicle.year_factory;
          this.vehicleFipeCode = res.vehicle.fipe_code;
          this.vehicleColor = res.vehicle.color;
          this.vehiclePorts = res.vehicle.ports;
          this.vehicleEngineNumber = res.vehicle.engine_number;
          this.vehicleRenavam = res.vehicle.renavam;
          this.vehicleCylinderCapacity = res.vehicle.cylinder_capacity;
          this.vehicleFuel = res.vehicle.fuel;
          this.vehiclePassengerQuantity = res.vehicle.passenger_quantity;
          this.fieldsWithValidation.fipeResult = res.vehicle.fipe_result;
          this.vehicleResult = res.vehicle.plate_result;

          if (res.vehicle.plate_result) {
            this.selectedFipeModel = res.vehicle.plate_result.fipe_data.find(
              (fipe) => fipe.fipe_code === res.vehicle.fipe_result.fipe_code,
            );
          }

          this.increases = res.all_increases.increases;
          this.zipCodeIncreases = res.all_increases.zipCodeIncreases;

          for (let increase of res.increases_answers) {
            const increaseComplete = this.increases.find(
              (inc) => inc.id === increase.id,
            );

            const response = increaseComplete.answers.find(
              (res) => res.id === increase.answers,
            );

            this.$set(
              this.fieldsWithValidation.increasesAnswers,
              increase.id,
              response,
            );
          }

          this.quoatiotionGenerated = true;
          this.prize = res.prize;

          this.products = res.all_coverages.details;
          if (res.coverage_contracted.length > 0) {
            this.selectedProducts = [...res.coverage_contracted];
          } else {
            this.setDefaultSelectedProducts();
          }

          res.charges.map((charge) => {
            this.form.carregamentos[charge.label] = {
              idCarregamento: charge.id,
              label: charge.label,
              porcentagem: charge.percentage,
              createdAt: charge.createdAt,
              updatedAt: charge.updatedAt,
              deletedAt: charge.deletedAt,
            };
          });

          if (!this.brokers.length) {
            this.brokers = [
              {
                id: this.quotation.broker.id,
                label: this.quotation.broker.name,
              },
            ];
          }

          this.form.desconto = res.prize.discount;
        })
        .catch((e) => {
          console.error('ERRO COTACAO', e);
          this.$router.push({ name: 'pageError404' });
        })
        .finally(() => {
          this.getCongeners(this.fieldsWithValidation.insuranceCompanyCode);
        });
    },

    getCharges() {
      autoApi
        .getCharges()
        .then((res) => {
          res.map((charge) => {
            this.form.carregamentos[charge.label] = {
              idCarregamento: charge.id,
              label: charge.label,
              porcentagem: charge.default,
              createdAt: charge.createdAt,
              updatedAt: charge.updatedAt,
              deletedAt: charge.deletedAt,
            };
          });
        })
        .catch(() => {
          notify.notifyFail(this.$vs, 'Erro ao buscar as corretoras');
        });
    },
    getVehicleTypes() {
      autoApi
        .getVehicleTypes()
        .then((res) => {
          this.vehicleTypes = res;
        })
        .catch((e) => {
          console.error(e);
          notify.notifyFail(this.$vs, 'Erro ao buscar os tipos de veículos');
        });
    },
    getVehicleBrands() {
      autoApi
        .getVehicleBrands(this.vehicleTypeId.id)
        .then((res) => {
          this.vehicleBrands = res.map((brand) => {
            return {
              id: brand.id,
              label: brand.brand,
            };
          });

          if (this.fieldsWithValidation.vehicleBrandId) {
            const brandId = this.vehicleBrands.find((brand) => {
              return brand.id == this.fieldsWithValidation.vehicleBrandId.id;
            });

            if (brandId) {
              this.fieldsWithValidation.vehicleBrandId = brandId;
              this.getVehicleModels();
            }
          }
        })
        .catch((e) => {
          console.error(e);
          notify.notifyFail(this.$vs, 'Erro ao buscar as marcas');
        });
    },
    getVehicleModels() {
      if (!this.fieldsWithValidation.vehicleBrandId) {
        return this.getVehicleBrands();
      }

      autoApi
        .getVehicleModels(
          this.vehicleTypeId.id,
          this.fieldsWithValidation.vehicleBrandId.id,
        )
        .then((res) => {
          this.vehicleModels = res.models.map((model) => {
            return {
              id: model.id,
              label: model.model,
            };
          });

          this.vehicleYearsModel = res.years.map((year) => {
            return {
              id: year.year,
              label: year.year,
              fuel: year.fuel,
              year: year.id,
            };
          });

          if (
            this.fieldsWithValidation.vehicleModelId &&
            this.fieldsWithValidation.vehicleYearModel
          ) {
            this.fieldsWithValidation.vehicleModelId = this.vehicleModels.find(
              (model) => {
                return model.id == this.fieldsWithValidation.vehicleModelId.id;
              },
            );

            this.fieldsWithValidation.vehicleYearModel =
              this.vehicleYearsModel.find((year) => {
                return (
                  year.year == this.fieldsWithValidation.vehicleYearModel.year
                );
              });
          }
        })
        .catch((e) => {
          console.error(e);
          notify.notifyFail(this.$vs, 'Erro ao buscar os anos modelo');
        });
    },
    getVehicleYears() {
      if (!this.fieldsWithValidation.vehicleModelId) {
        this.fieldsWithValidation.fipeResult = null;
        return this.getVehicleModels();
      }

      autoApi
        .getVehicleYears(
          this.vehicleTypeId.id,
          this.fieldsWithValidation.vehicleBrandId.id,
          this.fieldsWithValidation.vehicleModelId.id,
        )
        .then((res) => {
          this.vehicleYearsModel = res.map((year) => {
            return {
              id: year.year,
              label: year.year,
              fuel: year.fuel,
              year: year.id,
            };
          });

          if (this.fieldsWithValidation.vehicleYearModel) {
            const hasYear = this.vehicleYearsModel.some(
              (year) =>
                year.id == this.fieldsWithValidation.vehicleYearModel.id,
            );

            if (!hasYear) {
              this.fieldsWithValidation.vehicleYearModel = null;
            }

            if (
              this.fieldsWithValidation.vehicleModelId &&
              this.fieldsWithValidation.vehicleYearModel
            ) {
              return this.getFipe();
            }
          }
        })
        .catch((e) => {
          console.error(e);
          notify.notifyFail(this.$vs, 'Erro ao buscar os anos modelo');
        });
    },
    getVehicleModelsByYear() {
      if (!this.fieldsWithValidation.vehicleYearModel) {
        this.fieldsWithValidation.fipeResult = null;
        return this.getVehicleModels();
      }

      this.vehicleFuelId = this.fieldsWithValidation.vehicleYearModel.fuel;

      autoApi
        .getVehicleModelsByYear(
          this.vehicleTypeId.id,
          this.fieldsWithValidation.vehicleBrandId.id,
          this.fieldsWithValidation.vehicleYearModel.year,
        )
        .then((res) => {
          this.vehicleModels = res.map((model) => {
            return {
              id: model.id,
              label: model.model,
            };
          });

          if (this.fieldsWithValidation.vehicleModelId) {
            const hasModel = this.vehicleModels.some(
              (model) =>
                model.id == this.fieldsWithValidation.vehicleModelId.id,
            );

            if (!hasModel) {
              this.fieldsWithValidation.vehicleModelId = null;
            }

            if (
              this.fieldsWithValidation.vehicleModelId &&
              this.fieldsWithValidation.vehicleYearModel
            ) {
              return this.getFipe();
            }
          }
        })
        .catch((e) => {
          console.error(e);
          notify.notifyFail(this.$vs, 'Erro ao buscar os modelos');
        });
    },
    getFipe() {
      const vehicleYearModelId = this.isBrandNew
        ? ZERO_KM_VEHICLE_YEAR_ID
        : this.fieldsWithValidation.vehicleYearModel.year;
      autoApi
        .getFipe(
          this.vehicleTypeId.id,
          this.fieldsWithValidation.vehicleBrandId.id,
          this.fieldsWithValidation.vehicleModelId.id,
          vehicleYearModelId,
          this.vehicleFuelId,
        )
        .then((res) => {
          if (res && res.amount) {
            this.fieldsWithValidation.fipeResult = res;
          } else {
            this.fieldsWithValidation.fipeResult = { amount: 0 };
          }
          this.getIncreases();
        })
        .catch((e) => {
          console.error(e);
          notify.notifyFail(this.$vs, 'Erro ao buscar a Tabela FIPE');
        });
    },
    async getFipeByCode() {
      const vehicleYearModelId = this.isBrandNew
        ? ZERO_KM_VEHICLE_YEAR_ID
        : this.fieldsWithValidation.vehicleYearModel.year;
      autoApi
        .getFipeByCode(
          this.vehicleTypeId.id,
          vehicleYearModelId,
          this.vehicleFuelId,
          this.vehicleFipeCode,
        )
        .then((res) => {
          this.fieldsWithValidation.fipeResult = res;
          this.getIncreases();
        })
        .catch((e) => {
          console.error(e);
          notify.notifyFail(this.$vs, 'Erro ao buscar a Tabela FIPE');
        });
    },
    changeFipeResult() {
      this.fieldsWithValidation.fipeResult = {
        amount: this.selectedFipeModel.value_text,
        brand: this.selectedFipeModel.brand_text,
        fipe_code: this.selectedFipeModel.fipe_code,
        fuel: this.selectedFipeModel.fuel || this.selectedFipeModel.fuel_code,
        fuel_initials: this.selectedFipeModel.fuel_abbreviation,
        model: this.selectedFipeModel.model_text,
        vehicle_type: this.selectedFipeModel.type_id,
        year_model: Number(this.selectedFipeModel.year_model),
      };
      this.getIncreases();
    },
    getIncreases() {
      if (!this.fieldsWithValidation.overnightZipCode) return;

      autoApi
        .getIncreases(this.fieldsWithValidation.overnightZipCode)
        .then((res) => {
          this.increases = res.increases;
          this.zipCodeIncreases = res.zipCodeIncreases;
        })
        .catch(() => {
          notify.notifyFail(this.$vs, 'Erro ao buscar as coberturas');
        });
    },
    nextStep() {
      if (this.step === 0 && !this.fieldsWithValidation.brokerId) {
        notify.notifyFail(
          this.$vs,
          'Selecione uma corretora antes de continuar',
        );
        return;
      }

      if (this.step == 2) {
        this.calculate();
      }

      this.step++;
    },
    buscaDadosSelects(model, array, campoDescricao, campoPK) {
      service.getAll('g', {}, `${model}/list/`).then((res) => {
        res.data.forEach((element) => {
          this[array].push({
            id: element[campoPK],
            label: element[campoDescricao],
          });
        });

        this[array].sort(function (a, b) {
          return a.label < b.label ? -1 : a.label > b.label ? 1 : 0;
        });
        this[array].unshift({ id: null, label: 'Selecione' });
      });
    },
    keymonitor: function () {
      if (this.fieldsWithValidation.overnightZipCode.length == 10) {
        this.$vs.loading();

        this.getIncreases();

        var cepbusca = this.fieldsWithValidation.overnightZipCode
          .replace('.', '')
          .replace('-', '');
        service
          .post('g', 'BuscaCEP', {
            cep: cepbusca,
          })
          .then((res) => {
            this.cepApiResult = !!res.data;
            this.fieldsWithValidation.overnightStreet = res.data.street;
            this.fieldsWithValidation.overnightNeighborhood =
              res.data.neighborhood;
            this.fieldsWithValidation.overnightCity = res.data.city;
            this.fieldsWithValidation.overnightState = res.data.state;

            this.hasCepApiReturnedOvernightStreet =
              this.fieldsWithValidation.overnightStreet != '';
            this.hasCepApiReturnedOvernightNeighborhood =
              this.fieldsWithValidation.overnightNeighborhood != '';
            this.hasCepApiReturnedOvernightState =
              this.fieldsWithValidation.overnightState != '';
            this.hasCepApiReturnedOvernightCity =
              this.fieldsWithValidation.overnightCity != '';

            this.$vs.loading.close();
          })
          .catch(() => {
            this.cepApiResult = false;
            this.fieldsWithValidation.overnightStreet = null;
            this.fieldsWithValidation.overnightNeighborhood = null;
            this.fieldsWithValidation.overnightCity = null;
            this.fieldsWithValidation.overnightState = null;
            this.$vs.loading.close();
            notify.notifyFail(this.$vs, 'Não foi possível encontrar o cep');
          });
      }
    },
    async setSelectedVehicleModel(selectedVehicleModel) {
      if (!selectedVehicleModel) {
        this.showSelectPlateModal = false;
        this.resetModalVehicleModel = false;
        this.selectedFipeModel = null;
        this.fieldsWithValidation.vehicleBrandId = null;
        this.fieldsWithValidation.vehicleModelId = null;
        this.vehicleFuelId = null;
        this.fieldsWithValidation.vehicleYearModel = null;
        this.vehicleBrand = null;
        this.vehicleModel = null;
        this.vehicleFipeCode = null;
        this.fieldsWithValidation.fipeResult = null;
        this.vehicleTypeId = this.vehicleTypes.find(
          (vehicleType) =>
            vehicleType.id === this.vehicleResult.fipe_data[0].type_id,
        );
        this.filledManually = true;
        return;
      }

      this.selectedFipeModel = selectedVehicleModel;
      if (
        this.selectedFipeModel.fuel_code &&
        this.selectedFipeModel.fuel_code === FUEL_TYPE_CODES.ELECTRIC
      ) {
        this.selectedFipeModel.fuel = FUEL_TYPE_NAMES.ELECTRIC;
        this.vehicleFuel = this.selectedFipeModel.fuel;
      }
      this.vehicleTypeId = this.vehicleTypes.find(
        (vehicleType) => vehicleType.id === this.selectedFipeModel.type_id,
      );
      this.fieldsWithValidation.vehicleBrandId = {
        id: this.selectedFipeModel.brand_id,
        label: this.selectedFipeModel.brand_text,
      };
      this.fieldsWithValidation.vehicleModelId = {
        id: this.selectedFipeModel.model_id,
        label: this.selectedFipeModel.model_text,
      };
      this.vehicleFuelId =
        this.fuelCode[this.selectedFipeModel.fuel_abbreviation];
      const yearModelLabel = this.getVehicleYearModelLabel(
        this.selectedFipeModel,
      );
      this.fieldsWithValidation.vehicleYearModel = {
        id: yearModelLabel,
        label: yearModelLabel,
        fuel: this.selectedFipeModel.fuel,
        year: this.selectedFipeModel.year_model,
      };
      this.vehicleModel = this.selectedFipeModel.model_text;
      this.vehicleFipeCode = this.selectedFipeModel.fipe_code;
      if (this.selectedFipeModel.correct_data && this.isBrandNew) {
        await this.getFipeByCode();
      } else {
        this.changeFipeResult();
      }
      this.showSelectPlateModal = false;
      this.resetModalVehicleModel = false;
      this.filledManually = false;
    },
    setMonitoredVehicleData(res) {
      this.vehicleResult = res;
      this.selectedFipeModel = null;
      this.fieldsWithValidation.vehicleChassis =
        this.vehicleResult.extra_data.chassis_number;
      this.vehicleEngineNumber = this.vehicleResult.extra_data.motor;
      this.vehicleCylinderCapacity =
        this.vehicleResult.extra_data.cylinder_capacity;
      this.vehicleFuel = this.vehicleResult.extra_data.fuel;
      this.vehiclePassengerQuantity =
        this.vehicleResult.extra_data.passenger_count;
      this.vehicleBrand = this.vehicleResult.brand;
      this.vehicleYearFactory = this.vehicleResult.year;
      this.vehicleColor = this.vehicleResult.color;
      this.vehicleRenavam = this.vehicleResult.extra_data.renavam;
      if (!res) return;
      this.resetModalVehicleModel = true;
      this.showSelectPlateModal = true;
    },
    async keymonitorPlate() {
      if (
        !this.fieldsWithValidation.vehiclePlate ||
        this.fieldsWithValidation.vehiclePlate.length < 8 ||
        this.searchingPlate
      ) {
        this.clearVehicleData();
        return;
      }

      this.searchingPlate = true;
      this.$vs.loading();

      autoApi
        .getVehicleByPlate(this.fieldsWithValidation.vehiclePlate)
        .then((res) => {
          if (!res) {
            notify.notifyFail(
              this.$vs,
              'Nenhum modelo encontrado com essa placa ou chassi',
            );
            this.clearVehicleData();
            return;
          }

          this.setMonitoredVehicleData(res);
        })
        .catch(() => {
          notify.notifyFail(this.$vs, 'Erro ao buscar os dados do veículo');
        })
        .finally(() => {
          this.searchingPlate = false;
          this.$vs.loading.close();
        });
    },
    async keymonitorChassi() {
      if (!this.isBrandNew) return;
      if (
        !this.fieldsWithValidation.vehicleChassis ||
        this.fieldsWithValidation.vehicleChassis.length < 17 ||
        this.searchingChassi
      ) {
        this.clearVehicleDataWithOutChassi();
        return;
      }

      this.searchingChassi = true;
      this.$vs.loading();

      autoApi
        .getVehicleByChassi(this.fieldsWithValidation.vehicleChassis)
        .then((res) => {
          this.setMonitoredVehicleData(res);
        })
        .catch(() => {
          notify.notifyFail(
            this.$vs,
            'Nenhum modelo encontrado com essa placa ou chassi',
          );

          this.clearVehicleDataWithOutChassi();
        })
        .finally(() => {
          this.searchingChassi = false;
          this.$vs.loading.close();
        });
    },
    getCityData(model, array, campoDescricao, campoPK) {
      if (!this.fieldsWithValidation.overnightState) {
        this[array] = [];
        this.fieldsWithValidation.overnightCity = null;
        return;
      }

      this.$vs.loading();
      this[array] = [];
      if (
        this.fieldsWithValidation.overnightState &&
        this.fieldsWithValidation.overnightState.id
      ) {
        this.$vs.loading();

        service
          .getAll(
            'g',
            {},
            `${model}/list/codUf/${this.fieldsWithValidation.overnightState.id}`,
          )
          .then((res) => {
            if (res)
              res.data.forEach((element) => {
                this[array].push({
                  id: element[campoPK],
                  label: element[campoDescricao],
                });
              });

            this.$vs.loading.close();
          });
      }
    },
    selectState() {
      if (!this.fieldsWithValidation.overnightState) {
        this.fieldsWithValidation.overnightCity = null;
        return;
      }

      const aux = this.estados.find(
        (x) => x.id == this.fieldsWithValidation.overnightState.id,
      );
      this.fieldsWithValidation.overnightState = aux.label;
    },
    selectCity() {
      if (!this.fieldsWithValidation.overnightCity) {
        this.fieldsWithValidation.overnightCity = null;
        return;
      }

      var aux = this.cidades.find(
        (x) => x.id == this.fieldsWithValidation.overnightCity.id,
      );
      this.fieldsWithValidation.overnightCity = aux.label;
    },
    converteParams() {
      if (this.$route.query.hideLogo) {
        this.hideLogo = JSON.parse(this.$route.query.hideLogo.toLowerCase());
      } else this.hideLogo = false;

      if (this.$route.query.showPanel) {
        this.showPanel = JSON.parse(this.$route.query.showPanel.toLowerCase());
      } else this.showPanel = true;

      if (this.$route.query.fixedButton) {
        this.fixedButton = JSON.parse(
          this.$route.query.fixedButton.toLowerCase(),
        );
      } else this.fixedButton = false;

      if (this.$route.query.isRedirect) {
        this.isRedirect = JSON.parse(
          this.$route.query.isRedirect.toLowerCase(),
        );
      } else this.isRedirect = true;
    },
    openModalLogs() {
      this.modalLogs = true;
    },
    closeModalLogs() {
      this.modalLogs = false;
    },
    closeMessagingModal() {
      this.modalHistoricoMensageria = false;
    },
    cancelChanges() {
      window.location.href = '/Cotacoes';
    },
    loggedUserIsInBroker() {
      const token = localStorage.getItem('user-token');
      const decoded = jwt.decode(token);
      if (decoded.id_regional && this.step === 0) {
        this.fieldsWithValidation.brokerId = decoded.id_regional;
        this.nextStep();
      }
    },
    recusarCorretora(id) {
      this.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: `Confirmar`,
        text: 'Tem certeza que deseja cancelar esta cotação/proposta? Essa ação é irreversível.',
        acceptText: 'Confirmar',
        cancelText: 'Cancelar',
        accept: () => this.recusar(id),
      });
    },
    recusar(id) {
      const formRecusa = {
        idApolice: id,
        obsRecusa: null,
        idMotivoRecusa: ID_MOTIVO_RECUSA_CORRETORA_PADRAO,
      };

      const controller = 'auto';
      const action = 'refuse/' + formRecusa.idApolice;
      const data = {
        reasonId: formRecusa.idMotivoRecusa,
        description: formRecusa.obsRecusa,
      };

      this.$vs.loading();
      lifeService.update(controller, data, action).then(() => {
        this.$vs.loading.close();
        notify.notifySuccess(
          this.$vs,
          `${this.getLabelContrato()} cancelada com sucesso!`,
        );
      });
      this.getQuotation();
    },
    getQuotationConfigs() {
      autoApi
        .getQuotationConfigs()
        .then((res) => {
          this.listAllowedStates = res.statesAllowed
            .replace(' ', '')
            .split(',');
          this.maxRcfCoverageValue = res.maxRcfCoverageValue;
          this.createDynamicValidations();
        })
        .catch(() => {
          notify.notifyFail(
            this.$vs,
            'Não foi possível buscar as configurações de cotação',
          );
        });
    },
    getCongeners(susepCode) {
      autoApi
        .getCongenersLabeled(susepCode)
        .then((res) => {
          this.insuranceCompanies = [];
          res.forEach((congener) => {
            this.insuranceCompanies.push({
              id: congener.susep_code,
              label: congener.name,
            });
          });
        })
        .catch(() => {
          notify.notifyFail(
            this.$vs,
            'Não foi possível buscar a lista de congêneres',
          );
        });
    },
  },
  async created() {
    this.createValidations();
    this.getBrokers();
    this.getCharges();
    this.getVehicleTypes();
    this.getBrokerAccountConfigs();
    this.getQuotationConfigs();
    this.buscaDadosSelects('domUf', 'estados', 'nomeUf', 'codUf');
    this.converteParams();

    if (this.$route.params.id) {
      this.id = this.$route.params.id;
      this.getQuotation();
    } else {
      this.getCongeners();
    }

    this.getVehicleBrands();
  },
  async mounted() {
    this.$refs.newQuotationForm.validate();
    window.addEventListener('resize', this.updateWidth);
    this.loggedUserIsInBroker();
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.updateWidth);
  },
  components: {
    ModalProposalHistory,
    ModalSelectVehicleModel,
    'v-select': vSelect,
    Money,
    CarregamentosForm,
    ModalHistoricoMensageria,
    ProductsList,
    FinancialSummary,
    Modal,
    ValidationObserver,
    ValidationProvider,
    ModalPriceChange,
  },
};
</script>
<style lang="scss">
.form-landing {
  font-family: 'Roboto';
  padding-top: 60px;
  min-height: 80vh;

  .coluna-switch {
    padding: 0px 5px;

    div {
      background-color: #eff7ff;
      padding: 10px;
      min-height: 60px;
      vertical-align: middle;

      .label-switch {
        font-size: 12px;
        color: #078fcf;
      }
    }
  }

  label,
  .vs-input--label {
    color: #078fcf !important;
    font-size: 1rem;
  }

  .vs-input--input,
  .vs__dropdown-toggle,
  .vs-con-input .vs-inputx {
    height: 52px;
    background: white;
    border-radius: 9px;
    border: 1px #eeeeee solid !important;
  }
}

.botaoContratarAgora {
  background-color: #158c12;
  border-radius: 1rem;
  font-size: 1rem;
  color: #ffffff;
  padding: 1rem 2rem 1rem 2rem;
  transition: background-color 0.3s;
  font-family: 'Product Sans', sans-serif;
  cursor: pointer;
  border: 0;
  text-align: center;

  img {
    float: right;
    margin-top: 5px;
  }
}

.checkBoxNomeSocial {
  align-self: center;
}
</style>
<style scoped>
.input-data {
  width: 300px !important;
  max-width: 100% !important;
}

body {
  background-color: white;
}
.con-slot-label {
  width: 100%;
  margin-left: 10px;
}

.semPadding {
  padding: 0em 0em 0em 0em !important;
}

.container {
  display: flex;
  flex-direction: row;
  align-items: center;
}

.my-custom-money {
  font-size: 1.5em;
  color: #555555;
}

.my-custom-money-danger {
  font-size: 1.5em;
  color: #ea5455;
}

.my-custom-input {
  width: 100%;
  padding: 0.5em;
  border: 2px solid #b4b4b4;
  border-radius: 8px;
}

.my-custom-input-danger {
  width: 100%;
  padding: 0.5em;
  border: 2px solid #ea5455;
  border-radius: 8px;
}

#meu-popup-personalizado.con-vs-popup .vs-popup {
  width: fit-content;
}
</style>
<style lang="scss" scoped>
.vs__search,
.vs__search:focus {
  padding: 0 6px !important;
}

.vehicle-alert {
  background-color: rgba(var(--vs-primary), 0.15);
}

.fixed-buttons {
  position: fixed;
  bottom: 0;
  width: 100%;
  border-top: 1px solid #ccc;
  padding: 10px;
  margin-left: -25px;
  background-color: #fff;
  z-index: 999;
}

.painel-no-border {
  box-shadow: none !important;
  padding-bottom: 70px;
}

.table-bordered {
  display: table;
  border-collapse: separate;
  box-sizing: border-box;
  border-spacing: 2px;
  border-color: grey;
  width: 100%;

  tr td {
    padding: 10px;
  }

  tr:nth-child(2n) {
    background: #efefef !important;
  }
}

.item-lista {
  border: 1px solid #ccc;
  padding: 15px;
}

.form-part-title {
  padding: 1em;
  background: #d8e2ff;

  span {
    color: #2b50bb;
    font-weight: 600;
  }
}

.input-data-ativacao {
  width: 100%;
}
</style>
<style lang="scss" scoped>
.title-item-veiculo {
  border-bottom: 1px solid #000;
}

.text-danger {
  font-size: 12px;
}

.no-padding-cols > .vs-col {
  padding: 0 !important;
}

.tooltip-wrapper {
  position: relative;
  display: inline-block;
  cursor: pointer;
}

.tooltip {
  visibility: hidden;
  width: 200px;
  background-color: black;
  color: #fff;
  text-align: center;
  padding: 5px 0;
  border-radius: 4px;

  position: absolute;
  z-index: 1;
  bottom: 100%;
  left: 50%;
  margin-left: -60px;

  opacity: 0;
  transition: opacity 0.3s;
}

.tooltip-wrapper:hover .tooltip {
  visibility: visible;
  opacity: 1;
}

.loading-financial-wrapper {
  display: flex;
  flex-direction: column;
  gap: 4rem;
}

.loading-financial-list-wrapper {
  width: 100%;
  max-width: 100rem;
}

@media (min-width: 768px) {
  .loading-financial-wrapper {
    flex-direction: row;
    justify-content: space-between;
  }
  .loading-financial-list-wrapper {
    width: 47%;
  }
}

.purple-gradient-btn {
  background: #000000 !important;
  background-image: linear-gradient(
    30deg,
    rgba(135, 81, 252, 1),
    rgba(135, 81, 252, 0.5)
  ) !important;
}
</style>
